import t, { withManager as e, withResizable as n, withMargin as r, withPosition as i, withDimensions as s, withHighlight as o } from "@nightingale-elements/nightingale-new-core";
function a(t, e, n, r) {
  var i,
    s = arguments.length,
    o = s < 3 ? e : null === r ? r = Object.getOwnPropertyDescriptor(e, n) : r;
  if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) o = Reflect.decorate(t, e, n, r);else for (var a = t.length - 1; a >= 0; a--) (i = t[a]) && (o = (s < 3 ? i(o) : s > 3 ? i(e, n, o) : i(e, n)) || o);
  return s > 3 && o && Object.defineProperty(e, n, o), o;
}
function l(t, e, n, r) {
  if ("a" === n && !r) throw new TypeError("Private accessor was defined without a getter");
  if ("function" == typeof e ? t !== e || !r : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return "m" === n ? r : "a" === n ? r.call(t) : r ? r.value : e.get(t);
}
function u(t, e, n, r, i) {
  if ("m" === r) throw new TypeError("Private method is not writable");
  if ("a" === r && !i) throw new TypeError("Private accessor was defined without a setter");
  if ("function" == typeof e ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return "a" === r ? i.call(t, n) : i ? i.value = n : e.set(t, n), n;
}
"function" == typeof SuppressedError && SuppressedError;
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const h = window,
  c = h.ShadowRoot && (void 0 === h.ShadyCSS || h.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype,
  f = Symbol(),
  d = new WeakMap();
const p = t => new class {
    constructor(t, e, n) {
      if (this._$cssResult$ = !0, n !== f) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
      this.cssText = t, this.t = e;
    }
    get styleSheet() {
      let t = this.o;
      const e = this.t;
      if (c && void 0 === t) {
        const n = void 0 !== e && 1 === e.length;
        n && (t = d.get(e)), void 0 === t && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), n && d.set(e, t));
      }
      return t;
    }
    toString() {
      return this.cssText;
    }
  }("string" == typeof t ? t : t + "", void 0, f),
  g = c ? t => t : t => t instanceof CSSStyleSheet ? (t => {
    let e = "";
    for (const n of t.cssRules) e += n.cssText;
    return p(e);
  })(t) : t
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */;
var v;
const m = window,
  y = m.trustedTypes,
  _ = y ? y.emptyScript : "",
  w = m.reactiveElementPolyfillSupport,
  b = {
    toAttribute(t, e) {
      switch (e) {
        case Boolean:
          t = t ? _ : null;
          break;
        case Object:
        case Array:
          t = null == t ? t : JSON.stringify(t);
      }
      return t;
    },
    fromAttribute(t, e) {
      let n = t;
      switch (e) {
        case Boolean:
          n = null !== t;
          break;
        case Number:
          n = null === t ? null : Number(t);
          break;
        case Object:
        case Array:
          try {
            n = JSON.parse(t);
          } catch (t) {
            n = null;
          }
      }
      return n;
    }
  },
  $ = (t, e) => e !== t && (e == e || t == t),
  A = {
    attribute: !0,
    type: String,
    converter: b,
    reflect: !1,
    hasChanged: $
  };
let x = class extends HTMLElement {
  constructor() {
    super(), this._$Ei = new Map(), this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this.u();
  }
  static addInitializer(t) {
    var e;
    this.finalize(), (null !== (e = this.h) && void 0 !== e ? e : this.h = []).push(t);
  }
  static get observedAttributes() {
    this.finalize();
    const t = [];
    return this.elementProperties.forEach((e, n) => {
      const r = this._$Ep(n, e);
      void 0 !== r && (this._$Ev.set(r, n), t.push(r));
    }), t;
  }
  static createProperty(t, e = A) {
    if (e.state && (e.attribute = !1), this.finalize(), this.elementProperties.set(t, e), !e.noAccessor && !this.prototype.hasOwnProperty(t)) {
      const n = "symbol" == typeof t ? Symbol() : "__" + t,
        r = this.getPropertyDescriptor(t, n, e);
      void 0 !== r && Object.defineProperty(this.prototype, t, r);
    }
  }
  static getPropertyDescriptor(t, e, n) {
    return {
      get() {
        return this[e];
      },
      set(r) {
        const i = this[t];
        this[e] = r, this.requestUpdate(t, i, n);
      },
      configurable: !0,
      enumerable: !0
    };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) || A;
  }
  static finalize() {
    if (this.hasOwnProperty("finalized")) return !1;
    this.finalized = !0;
    const t = Object.getPrototypeOf(this);
    if (t.finalize(), void 0 !== t.h && (this.h = [...t.h]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map(), this.hasOwnProperty("properties")) {
      const t = this.properties,
        e = [...Object.getOwnPropertyNames(t), ...Object.getOwnPropertySymbols(t)];
      for (const n of e) this.createProperty(n, t[n]);
    }
    return this.elementStyles = this.finalizeStyles(this.styles), !0;
  }
  static finalizeStyles(t) {
    const e = [];
    if (Array.isArray(t)) {
      const n = new Set(t.flat(1 / 0).reverse());
      for (const t of n) e.unshift(g(t));
    } else void 0 !== t && e.push(g(t));
    return e;
  }
  static _$Ep(t, e) {
    const n = e.attribute;
    return !1 === n ? void 0 : "string" == typeof n ? n : "string" == typeof t ? t.toLowerCase() : void 0;
  }
  u() {
    var t;
    this._$E_ = new Promise(t => this.enableUpdating = t), this._$AL = new Map(), this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach(t => t(this));
  }
  addController(t) {
    var e, n;
    (null !== (e = this._$ES) && void 0 !== e ? e : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (n = t.hostConnected) || void 0 === n || n.call(t));
  }
  removeController(t) {
    var e;
    null === (e = this._$ES) || void 0 === e || e.splice(this._$ES.indexOf(t) >>> 0, 1);
  }
  _$Eg() {
    this.constructor.elementProperties.forEach((t, e) => {
      this.hasOwnProperty(e) && (this._$Ei.set(e, this[e]), delete this[e]);
    });
  }
  createRenderRoot() {
    var t;
    const e = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
    return ((t, e) => {
      c ? t.adoptedStyleSheets = e.map(t => t instanceof CSSStyleSheet ? t : t.styleSheet) : e.forEach(e => {
        const n = document.createElement("style"),
          r = h.litNonce;
        void 0 !== r && n.setAttribute("nonce", r), n.textContent = e.cssText, t.appendChild(n);
      });
    })(e, this.constructor.elementStyles), e;
  }
  connectedCallback() {
    var t;
    void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach(t => {
      var e;
      return null === (e = t.hostConnected) || void 0 === e ? void 0 : e.call(t);
    });
  }
  enableUpdating(t) {}
  disconnectedCallback() {
    var t;
    null === (t = this._$ES) || void 0 === t || t.forEach(t => {
      var e;
      return null === (e = t.hostDisconnected) || void 0 === e ? void 0 : e.call(t);
    });
  }
  attributeChangedCallback(t, e, n) {
    this._$AK(t, n);
  }
  _$EO(t, e, n = A) {
    var r;
    const i = this.constructor._$Ep(t, n);
    if (void 0 !== i && !0 === n.reflect) {
      const s = (void 0 !== (null === (r = n.converter) || void 0 === r ? void 0 : r.toAttribute) ? n.converter : b).toAttribute(e, n.type);
      this._$El = t, null == s ? this.removeAttribute(i) : this.setAttribute(i, s), this._$El = null;
    }
  }
  _$AK(t, e) {
    var n;
    const r = this.constructor,
      i = r._$Ev.get(t);
    if (void 0 !== i && this._$El !== i) {
      const t = r.getPropertyOptions(i),
        s = "function" == typeof t.converter ? {
          fromAttribute: t.converter
        } : void 0 !== (null === (n = t.converter) || void 0 === n ? void 0 : n.fromAttribute) ? t.converter : b;
      this._$El = i, this[i] = s.fromAttribute(e, t.type), this._$El = null;
    }
  }
  requestUpdate(t, e, n) {
    let r = !0;
    void 0 !== t && (((n = n || this.constructor.getPropertyOptions(t)).hasChanged || $)(this[t], e) ? (this._$AL.has(t) || this._$AL.set(t, e), !0 === n.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map()), this._$EC.set(t, n))) : r = !1), !this.isUpdatePending && r && (this._$E_ = this._$Ej());
  }
  async _$Ej() {
    this.isUpdatePending = !0;
    try {
      await this._$E_;
    } catch (t) {
      Promise.reject(t);
    }
    const t = this.scheduleUpdate();
    return null != t && (await t), !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var t;
    if (!this.isUpdatePending) return;
    this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, e) => this[e] = t), this._$Ei = void 0);
    let e = !1;
    const n = this._$AL;
    try {
      e = this.shouldUpdate(n), e ? (this.willUpdate(n), null === (t = this._$ES) || void 0 === t || t.forEach(t => {
        var e;
        return null === (e = t.hostUpdate) || void 0 === e ? void 0 : e.call(t);
      }), this.update(n)) : this._$Ek();
    } catch (t) {
      throw e = !1, this._$Ek(), t;
    }
    e && this._$AE(n);
  }
  willUpdate(t) {}
  _$AE(t) {
    var e;
    null === (e = this._$ES) || void 0 === e || e.forEach(t => {
      var e;
      return null === (e = t.hostUpdated) || void 0 === e ? void 0 : e.call(t);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$Ek() {
    this._$AL = new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$E_;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    void 0 !== this._$EC && (this._$EC.forEach((t, e) => this._$EO(e, this[e], t)), this._$EC = void 0), this._$Ek();
  }
  updated(t) {}
  firstUpdated(t) {}
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var E;
x.finalized = !0, x.elementProperties = new Map(), x.elementStyles = [], x.shadowRootOptions = {
  mode: "open"
}, null == w || w({
  ReactiveElement: x
}), (null !== (v = m.reactiveElementVersions) && void 0 !== v ? v : m.reactiveElementVersions = []).push("1.6.1");
const M = window,
  k = M.trustedTypes,
  S = k ? k.createPolicy("lit-html", {
    createHTML: t => t
  }) : void 0,
  N = "$lit$",
  C = `lit$${(Math.random() + "").slice(9)}$`,
  P = "?" + C,
  T = `<${P}>`,
  H = document,
  O = () => H.createComment(""),
  R = t => null === t || "object" != typeof t && "function" != typeof t,
  z = Array.isArray,
  U = "[ \t\n\f\r]",
  j = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,
  L = /-->/g,
  D = />/g,
  I = RegExp(`>|${U}(?:([^\\s"'>=/]+)(${U}*=${U}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"),
  V = /'/g,
  B = /"/g,
  q = /^(?:script|style|textarea|title)$/i,
  X = (t => (e, ...n) => ({
    _$litType$: t,
    strings: e,
    values: n
  }))(1),
  W = Symbol.for("lit-noChange"),
  Y = Symbol.for("lit-nothing"),
  F = new WeakMap(),
  K = H.createTreeWalker(H, 129, null, !1),
  G = (t, e) => {
    const n = t.length - 1,
      r = [];
    let i,
      s = 2 === e ? "<svg>" : "",
      o = j;
    for (let e = 0; e < n; e++) {
      const n = t[e];
      let a,
        l,
        u = -1,
        h = 0;
      for (; h < n.length && (o.lastIndex = h, l = o.exec(n), null !== l);) h = o.lastIndex, o === j ? "!--" === l[1] ? o = L : void 0 !== l[1] ? o = D : void 0 !== l[2] ? (q.test(l[2]) && (i = RegExp("</" + l[2], "g")), o = I) : void 0 !== l[3] && (o = I) : o === I ? ">" === l[0] ? (o = null != i ? i : j, u = -1) : void 0 === l[1] ? u = -2 : (u = o.lastIndex - l[2].length, a = l[1], o = void 0 === l[3] ? I : '"' === l[3] ? B : V) : o === B || o === V ? o = I : o === L || o === D ? o = j : (o = I, i = void 0);
      const c = o === I && t[e + 1].startsWith("/>") ? " " : "";
      s += o === j ? n + T : u >= 0 ? (r.push(a), n.slice(0, u) + N + n.slice(u) + C + c) : n + C + (-2 === u ? (r.push(void 0), e) : c);
    }
    const a = s + (t[n] || "<?>") + (2 === e ? "</svg>" : "");
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return [void 0 !== S ? S.createHTML(a) : a, r];
  };
class Z {
  constructor({
    strings: t,
    _$litType$: e
  }, n) {
    let r;
    this.parts = [];
    let i = 0,
      s = 0;
    const o = t.length - 1,
      a = this.parts,
      [l, u] = G(t, e);
    if (this.el = Z.createElement(l, n), K.currentNode = this.el.content, 2 === e) {
      const t = this.el.content,
        e = t.firstChild;
      e.remove(), t.append(...e.childNodes);
    }
    for (; null !== (r = K.nextNode()) && a.length < o;) {
      if (1 === r.nodeType) {
        if (r.hasAttributes()) {
          const t = [];
          for (const e of r.getAttributeNames()) if (e.endsWith(N) || e.startsWith(C)) {
            const n = u[s++];
            if (t.push(e), void 0 !== n) {
              const t = r.getAttribute(n.toLowerCase() + N).split(C),
                e = /([.?@])?(.*)/.exec(n);
              a.push({
                type: 1,
                index: i,
                name: e[2],
                strings: t,
                ctor: "." === e[1] ? nt : "?" === e[1] ? it : "@" === e[1] ? st : et
              });
            } else a.push({
              type: 6,
              index: i
            });
          }
          for (const e of t) r.removeAttribute(e);
        }
        if (q.test(r.tagName)) {
          const t = r.textContent.split(C),
            e = t.length - 1;
          if (e > 0) {
            r.textContent = k ? k.emptyScript : "";
            for (let n = 0; n < e; n++) r.append(t[n], O()), K.nextNode(), a.push({
              type: 2,
              index: ++i
            });
            r.append(t[e], O());
          }
        }
      } else if (8 === r.nodeType) if (r.data === P) a.push({
        type: 2,
        index: i
      });else {
        let t = -1;
        for (; -1 !== (t = r.data.indexOf(C, t + 1));) a.push({
          type: 7,
          index: i
        }), t += C.length - 1;
      }
      i++;
    }
  }
  static createElement(t, e) {
    const n = H.createElement("template");
    return n.innerHTML = t, n;
  }
}
function J(t, e, n = t, r) {
  var i, s, o, a;
  if (e === W) return e;
  let l = void 0 !== r ? null === (i = n._$Co) || void 0 === i ? void 0 : i[r] : n._$Cl;
  const u = R(e) ? void 0 : e._$litDirective$;
  return (null == l ? void 0 : l.constructor) !== u && (null === (s = null == l ? void 0 : l._$AO) || void 0 === s || s.call(l, !1), void 0 === u ? l = void 0 : (l = new u(t), l._$AT(t, n, r)), void 0 !== r ? (null !== (o = (a = n)._$Co) && void 0 !== o ? o : a._$Co = [])[r] = l : n._$Cl = l), void 0 !== l && (e = J(t, l._$AS(t, e.values), l, r)), e;
}
class Q {
  constructor(t, e) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = e;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    var e;
    const {
        el: {
          content: n
        },
        parts: r
      } = this._$AD,
      i = (null !== (e = null == t ? void 0 : t.creationScope) && void 0 !== e ? e : H).importNode(n, !0);
    K.currentNode = i;
    let s = K.nextNode(),
      o = 0,
      a = 0,
      l = r[0];
    for (; void 0 !== l;) {
      if (o === l.index) {
        let e;
        2 === l.type ? e = new tt(s, s.nextSibling, this, t) : 1 === l.type ? e = new l.ctor(s, l.name, l.strings, this, t) : 6 === l.type && (e = new ot(s, this, t)), this._$AV.push(e), l = r[++a];
      }
      o !== (null == l ? void 0 : l.index) && (s = K.nextNode(), o++);
    }
    return i;
  }
  v(t) {
    let e = 0;
    for (const n of this._$AV) void 0 !== n && (void 0 !== n.strings ? (n._$AI(t, n, e), e += n.strings.length - 2) : n._$AI(t[e])), e++;
  }
}
class tt {
  constructor(t, e, n, r) {
    var i;
    this.type = 2, this._$AH = Y, this._$AN = void 0, this._$AA = t, this._$AB = e, this._$AM = n, this.options = r, this._$Cp = null === (i = null == r ? void 0 : r.isConnected) || void 0 === i || i;
  }
  get _$AU() {
    var t, e;
    return null !== (e = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== e ? e : this._$Cp;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const e = this._$AM;
    return void 0 !== e && 11 === (null == t ? void 0 : t.nodeType) && (t = e.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, e = this) {
    t = J(this, t, e), R(t) ? t === Y || null == t || "" === t ? (this._$AH !== Y && this._$AR(), this._$AH = Y) : t !== this._$AH && t !== W && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : (t => z(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]))(t) ? this.T(t) : this._(t);
  }
  k(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  $(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
  }
  _(t) {
    this._$AH !== Y && R(this._$AH) ? this._$AA.nextSibling.data = t : this.$(H.createTextNode(t)), this._$AH = t;
  }
  g(t) {
    var e;
    const {
        values: n,
        _$litType$: r
      } = t,
      i = "number" == typeof r ? this._$AC(t) : (void 0 === r.el && (r.el = Z.createElement(r.h, this.options)), r);
    if ((null === (e = this._$AH) || void 0 === e ? void 0 : e._$AD) === i) this._$AH.v(n);else {
      const t = new Q(i, this),
        e = t.u(this.options);
      t.v(n), this.$(e), this._$AH = t;
    }
  }
  _$AC(t) {
    let e = F.get(t.strings);
    return void 0 === e && F.set(t.strings, e = new Z(t)), e;
  }
  T(t) {
    z(this._$AH) || (this._$AH = [], this._$AR());
    const e = this._$AH;
    let n,
      r = 0;
    for (const i of t) r === e.length ? e.push(n = new tt(this.k(O()), this.k(O()), this, this.options)) : n = e[r], n._$AI(i), r++;
    r < e.length && (this._$AR(n && n._$AB.nextSibling, r), e.length = r);
  }
  _$AR(t = this._$AA.nextSibling, e) {
    var n;
    for (null === (n = this._$AP) || void 0 === n || n.call(this, !1, !0, e); t && t !== this._$AB;) {
      const e = t.nextSibling;
      t.remove(), t = e;
    }
  }
  setConnected(t) {
    var e;
    void 0 === this._$AM && (this._$Cp = t, null === (e = this._$AP) || void 0 === e || e.call(this, t));
  }
}
class et {
  constructor(t, e, n, r, i) {
    this.type = 1, this._$AH = Y, this._$AN = void 0, this.element = t, this.name = e, this._$AM = r, this.options = i, n.length > 2 || "" !== n[0] || "" !== n[1] ? (this._$AH = Array(n.length - 1).fill(new String()), this.strings = n) : this._$AH = Y;
  }
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t, e = this, n, r) {
    const i = this.strings;
    let s = !1;
    if (void 0 === i) t = J(this, t, e, 0), s = !R(t) || t !== this._$AH && t !== W, s && (this._$AH = t);else {
      const r = t;
      let o, a;
      for (t = i[0], o = 0; o < i.length - 1; o++) a = J(this, r[n + o], e, o), a === W && (a = this._$AH[o]), s || (s = !R(a) || a !== this._$AH[o]), a === Y ? t = Y : t !== Y && (t += (null != a ? a : "") + i[o + 1]), this._$AH[o] = a;
    }
    s && !r && this.j(t);
  }
  j(t) {
    t === Y ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
  }
}
class nt extends et {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === Y ? void 0 : t;
  }
}
const rt = k ? k.emptyScript : "";
class it extends et {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    t && t !== Y ? this.element.setAttribute(this.name, rt) : this.element.removeAttribute(this.name);
  }
}
class st extends et {
  constructor(t, e, n, r, i) {
    super(t, e, n, r, i), this.type = 5;
  }
  _$AI(t, e = this) {
    var n;
    if ((t = null !== (n = J(this, t, e, 0)) && void 0 !== n ? n : Y) === W) return;
    const r = this._$AH,
      i = t === Y && r !== Y || t.capture !== r.capture || t.once !== r.once || t.passive !== r.passive,
      s = t !== Y && (r === Y || i);
    i && this.element.removeEventListener(this.name, this, r), s && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    var e, n;
    "function" == typeof this._$AH ? this._$AH.call(null !== (n = null === (e = this.options) || void 0 === e ? void 0 : e.host) && void 0 !== n ? n : this.element, t) : this._$AH.handleEvent(t);
  }
}
class ot {
  constructor(t, e, n) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = n;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    J(this, t);
  }
}
const at = M.litHtmlPolyfillSupport;
null == at || at(Z, tt), (null !== (E = M.litHtmlVersions) && void 0 !== E ? E : M.litHtmlVersions = []).push("2.7.2");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var lt, ut;
class ht extends x {
  constructor() {
    super(...arguments), this.renderOptions = {
      host: this
    }, this._$Do = void 0;
  }
  createRenderRoot() {
    var t, e;
    const n = super.createRenderRoot();
    return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = n.firstChild), n;
  }
  update(t) {
    const e = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = ((t, e, n) => {
      var r, i;
      const s = null !== (r = null == n ? void 0 : n.renderBefore) && void 0 !== r ? r : e;
      let o = s._$litPart$;
      if (void 0 === o) {
        const t = null !== (i = null == n ? void 0 : n.renderBefore) && void 0 !== i ? i : null;
        s._$litPart$ = o = new tt(e.insertBefore(O(), t), t, void 0, null != n ? n : {});
      }
      return o._$AI(t), o;
    })(e, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var t;
    super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
  }
  render() {
    return W;
  }
}
ht.finalized = !0, ht._$litElement$ = !0, null === (lt = globalThis.litElementHydrateSupport) || void 0 === lt || lt.call(globalThis, {
  LitElement: ht
});
const ct = globalThis.litElementPolyfillSupport;
null == ct || ct({
  LitElement: ht
}), (null !== (ut = globalThis.litElementVersions) && void 0 !== ut ? ut : globalThis.litElementVersions = []).push("3.3.1");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const ft = (t, e) => "method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
  ...e,
  finisher(n) {
    n.createProperty(e.key, t);
  }
} : {
  kind: "field",
  key: Symbol(),
  placement: "own",
  descriptor: {},
  originalKey: e.key,
  initializer() {
    "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
  },
  finisher(n) {
    n.createProperty(e.key, t);
  }
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function dt(t) {
  return (e, n) => void 0 !== n ? ((t, e, n) => {
    e.constructor.createProperty(n, t);
  })(t, e, n) : ft(t, e);
  /**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */
}
var pt;
function gt(t, e) {
  return null == t || null == e ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function vt(t, e) {
  return null == t || null == e ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function mt(t) {
  let e, n, r;
  function i(t, r, i = 0, s = t.length) {
    if (i < s) {
      if (0 !== e(r, r)) return s;
      do {
        const e = i + s >>> 1;
        n(t[e], r) < 0 ? i = e + 1 : s = e;
      } while (i < s);
    }
    return i;
  }
  return 2 !== t.length ? (e = gt, n = (e, n) => gt(t(e), n), r = (e, n) => t(e) - n) : (e = t === gt || t === vt ? t : yt, n = t, r = t), {
    left: i,
    center: function (t, e, n = 0, s = t.length) {
      const o = i(t, e, n, s - 1);
      return o > n && r(t[o - 1], e) > -r(t[o], e) ? o - 1 : o;
    },
    right: function (t, r, i = 0, s = t.length) {
      if (i < s) {
        if (0 !== e(r, r)) return s;
        do {
          const e = i + s >>> 1;
          n(t[e], r) <= 0 ? i = e + 1 : s = e;
        } while (i < s);
      }
      return i;
    }
  };
}
function yt() {
  return 0;
}
null === (pt = window.HTMLSlotElement) || void 0 === pt || pt.prototype.assignedElements;
const _t = mt(gt).right;
mt(function (t) {
  return null === t ? NaN : +t;
}).center;
var wt = _t;
const bt = Math.sqrt(50),
  $t = Math.sqrt(10),
  At = Math.sqrt(2);
function xt(t, e, n) {
  const r = (e - t) / Math.max(0, n),
    i = Math.floor(Math.log10(r)),
    s = r / Math.pow(10, i),
    o = s >= bt ? 10 : s >= $t ? 5 : s >= At ? 2 : 1;
  let a, l, u;
  return i < 0 ? (u = Math.pow(10, -i) / o, a = Math.round(t * u), l = Math.round(e * u), a / u < t && ++a, l / u > e && --l, u = -u) : (u = Math.pow(10, i) * o, a = Math.round(t / u), l = Math.round(e / u), a * u < t && ++a, l * u > e && --l), l < a && .5 <= n && n < 2 ? xt(t, e, 2 * n) : [a, l, u];
}
function Et(t, e, n) {
  return xt(t = +t, e = +e, n = +n)[2];
}
function Mt(t) {
  return t;
}
var kt = 1,
  St = 2,
  Nt = 3,
  Ct = 4,
  Pt = 1e-6;
function Tt(t) {
  return "translate(" + t + ",0)";
}
function Ht(t) {
  return "translate(0," + t + ")";
}
function Ot(t) {
  return e => +t(e);
}
function Rt(t, e) {
  return e = Math.max(0, t.bandwidth() - 2 * e) / 2, t.round() && (e = Math.round(e)), n => +t(n) + e;
}
function zt() {
  return !this.__axis;
}
function Ut(t, e) {
  var n = [],
    r = null,
    i = null,
    s = 6,
    o = 6,
    a = 3,
    l = "undefined" != typeof window && window.devicePixelRatio > 1 ? 0 : .5,
    u = t === kt || t === Ct ? -1 : 1,
    h = t === Ct || t === St ? "x" : "y",
    c = t === kt || t === Nt ? Tt : Ht;
  function f(f) {
    var d = r ?? (e.ticks ? e.ticks.apply(e, n) : e.domain()),
      p = i ?? (e.tickFormat ? e.tickFormat.apply(e, n) : Mt),
      g = Math.max(s, 0) + a,
      v = e.range(),
      m = +v[0] + l,
      y = +v[v.length - 1] + l,
      _ = (e.bandwidth ? Rt : Ot)(e.copy(), l),
      w = f.selection ? f.selection() : f,
      b = w.selectAll(".domain").data([null]),
      $ = w.selectAll(".tick").data(d, e).order(),
      A = $.exit(),
      x = $.enter().append("g").attr("class", "tick"),
      E = $.select("line"),
      M = $.select("text");
    b = b.merge(b.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), $ = $.merge(x), E = E.merge(x.append("line").attr("stroke", "currentColor").attr(h + "2", u * s)), M = M.merge(x.append("text").attr("fill", "currentColor").attr(h, u * g).attr("dy", t === kt ? "0em" : t === Nt ? "0.71em" : "0.32em")), f !== w && (b = b.transition(f), $ = $.transition(f), E = E.transition(f), M = M.transition(f), A = A.transition(f).attr("opacity", Pt).attr("transform", function (t) {
      return isFinite(t = _(t)) ? c(t + l) : this.getAttribute("transform");
    }), x.attr("opacity", Pt).attr("transform", function (t) {
      var e = this.parentNode.__axis;
      return c((e && isFinite(e = e(t)) ? e : _(t)) + l);
    })), A.remove(), b.attr("d", t === Ct || t === St ? o ? "M" + u * o + "," + m + "H" + l + "V" + y + "H" + u * o : "M" + l + "," + m + "V" + y : o ? "M" + m + "," + u * o + "V" + l + "H" + y + "V" + u * o : "M" + m + "," + l + "H" + y), $.attr("opacity", 1).attr("transform", function (t) {
      return c(_(t) + l);
    }), E.attr(h + "2", u * s), M.attr(h, u * g).text(p), w.filter(zt).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", t === St ? "start" : t === Ct ? "end" : "middle"), w.each(function () {
      this.__axis = _;
    });
  }
  return f.scale = function (t) {
    return arguments.length ? (e = t, f) : e;
  }, f.ticks = function () {
    return n = Array.from(arguments), f;
  }, f.tickArguments = function (t) {
    return arguments.length ? (n = null == t ? [] : Array.from(t), f) : n.slice();
  }, f.tickValues = function (t) {
    return arguments.length ? (r = null == t ? null : Array.from(t), f) : r && r.slice();
  }, f.tickFormat = function (t) {
    return arguments.length ? (i = t, f) : i;
  }, f.tickSize = function (t) {
    return arguments.length ? (s = o = +t, f) : s;
  }, f.tickSizeInner = function (t) {
    return arguments.length ? (s = +t, f) : s;
  }, f.tickSizeOuter = function (t) {
    return arguments.length ? (o = +t, f) : o;
  }, f.tickPadding = function (t) {
    return arguments.length ? (a = +t, f) : a;
  }, f.offset = function (t) {
    return arguments.length ? (l = +t, f) : l;
  }, f;
}
var jt = {
  value: () => {}
};
function Lt() {
  for (var t, e = 0, n = arguments.length, r = {}; e < n; ++e) {
    if (!(t = arguments[e] + "") || t in r || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    r[t] = [];
  }
  return new Dt(r);
}
function Dt(t) {
  this._ = t;
}
function It(t, e) {
  for (var n, r = 0, i = t.length; r < i; ++r) if ((n = t[r]).name === e) return n.value;
}
function Vt(t, e, n) {
  for (var r = 0, i = t.length; r < i; ++r) if (t[r].name === e) {
    t[r] = jt, t = t.slice(0, r).concat(t.slice(r + 1));
    break;
  }
  return null != n && t.push({
    name: e,
    value: n
  }), t;
}
Dt.prototype = Lt.prototype = {
  constructor: Dt,
  on: function (t, e) {
    var n,
      r,
      i = this._,
      s = (r = i, (t + "").trim().split(/^|\s+/).map(function (t) {
        var e = "",
          n = t.indexOf(".");
        if (n >= 0 && (e = t.slice(n + 1), t = t.slice(0, n)), t && !r.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
          type: t,
          name: e
        };
      })),
      o = -1,
      a = s.length;
    if (!(arguments.length < 2)) {
      if (null != e && "function" != typeof e) throw new Error("invalid callback: " + e);
      for (; ++o < a;) if (n = (t = s[o]).type) i[n] = Vt(i[n], t.name, e);else if (null == e) for (n in i) i[n] = Vt(i[n], t.name, null);
      return this;
    }
    for (; ++o < a;) if ((n = (t = s[o]).type) && (n = It(i[n], t.name))) return n;
  },
  copy: function () {
    var t = {},
      e = this._;
    for (var n in e) t[n] = e[n].slice();
    return new Dt(t);
  },
  call: function (t, e) {
    if ((n = arguments.length - 2) > 0) for (var n, r, i = new Array(n), s = 0; s < n; ++s) i[s] = arguments[s + 2];
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (s = 0, n = (r = this._[t]).length; s < n; ++s) r[s].value.apply(e, i);
  },
  apply: function (t, e, n) {
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (var r = this._[t], i = 0, s = r.length; i < s; ++i) r[i].value.apply(e, n);
  }
};
var Bt = "http://www.w3.org/1999/xhtml",
  qt = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: Bt,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
  };
function Xt(t) {
  var e = t += "",
    n = e.indexOf(":");
  return n >= 0 && "xmlns" !== (e = t.slice(0, n)) && (t = t.slice(n + 1)), qt.hasOwnProperty(e) ? {
    space: qt[e],
    local: t
  } : t;
}
function Wt(t) {
  return function () {
    var e = this.ownerDocument,
      n = this.namespaceURI;
    return n === Bt && e.documentElement.namespaceURI === Bt ? e.createElement(t) : e.createElementNS(n, t);
  };
}
function Yt(t) {
  return function () {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function Ft(t) {
  var e = Xt(t);
  return (e.local ? Yt : Wt)(e);
}
function Kt() {}
function Gt(t) {
  return null == t ? Kt : function () {
    return this.querySelector(t);
  };
}
function Zt() {
  return [];
}
function Jt(t) {
  return null == t ? Zt : function () {
    return this.querySelectorAll(t);
  };
}
function Qt(t) {
  return function () {
    return function (t) {
      return null == t ? [] : Array.isArray(t) ? t : Array.from(t);
    }(t.apply(this, arguments));
  };
}
function te(t) {
  return function () {
    return this.matches(t);
  };
}
function ee(t) {
  return function (e) {
    return e.matches(t);
  };
}
var ne = Array.prototype.find;
function re() {
  return this.firstElementChild;
}
var ie = Array.prototype.filter;
function se() {
  return Array.from(this.children);
}
function oe(t) {
  return new Array(t.length);
}
function ae(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
function le(t, e, n, r, i, s) {
  for (var o, a = 0, l = e.length, u = s.length; a < u; ++a) (o = e[a]) ? (o.__data__ = s[a], r[a] = o) : n[a] = new ae(t, s[a]);
  for (; a < l; ++a) (o = e[a]) && (i[a] = o);
}
function ue(t, e, n, r, i, s, o) {
  var a,
    l,
    u,
    h = new Map(),
    c = e.length,
    f = s.length,
    d = new Array(c);
  for (a = 0; a < c; ++a) (l = e[a]) && (d[a] = u = o.call(l, l.__data__, a, e) + "", h.has(u) ? i[a] = l : h.set(u, l));
  for (a = 0; a < f; ++a) u = o.call(t, s[a], a, s) + "", (l = h.get(u)) ? (r[a] = l, l.__data__ = s[a], h.delete(u)) : n[a] = new ae(t, s[a]);
  for (a = 0; a < c; ++a) (l = e[a]) && h.get(d[a]) === l && (i[a] = l);
}
function he(t) {
  return t.__data__;
}
function ce(t) {
  return "object" == typeof t && "length" in t ? t : Array.from(t);
}
function fe(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function de(t) {
  return function () {
    this.removeAttribute(t);
  };
}
function pe(t) {
  return function () {
    this.removeAttributeNS(t.space, t.local);
  };
}
function ge(t, e) {
  return function () {
    this.setAttribute(t, e);
  };
}
function ve(t, e) {
  return function () {
    this.setAttributeNS(t.space, t.local, e);
  };
}
function me(t, e) {
  return function () {
    var n = e.apply(this, arguments);
    null == n ? this.removeAttribute(t) : this.setAttribute(t, n);
  };
}
function ye(t, e) {
  return function () {
    var n = e.apply(this, arguments);
    null == n ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
  };
}
function _e(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function we(t) {
  return function () {
    this.style.removeProperty(t);
  };
}
function be(t, e, n) {
  return function () {
    this.style.setProperty(t, e, n);
  };
}
function $e(t, e, n) {
  return function () {
    var r = e.apply(this, arguments);
    null == r ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
  };
}
function Ae(t, e) {
  return t.style.getPropertyValue(e) || _e(t).getComputedStyle(t, null).getPropertyValue(e);
}
function xe(t) {
  return function () {
    delete this[t];
  };
}
function Ee(t, e) {
  return function () {
    this[t] = e;
  };
}
function Me(t, e) {
  return function () {
    var n = e.apply(this, arguments);
    null == n ? delete this[t] : this[t] = n;
  };
}
function ke(t) {
  return t.trim().split(/^|\s+/);
}
function Se(t) {
  return t.classList || new Ne(t);
}
function Ne(t) {
  this._node = t, this._names = ke(t.getAttribute("class") || "");
}
function Ce(t, e) {
  for (var n = Se(t), r = -1, i = e.length; ++r < i;) n.add(e[r]);
}
function Pe(t, e) {
  for (var n = Se(t), r = -1, i = e.length; ++r < i;) n.remove(e[r]);
}
function Te(t) {
  return function () {
    Ce(this, t);
  };
}
function He(t) {
  return function () {
    Pe(this, t);
  };
}
function Oe(t, e) {
  return function () {
    (e.apply(this, arguments) ? Ce : Pe)(this, t);
  };
}
function Re() {
  this.textContent = "";
}
function ze(t) {
  return function () {
    this.textContent = t;
  };
}
function Ue(t) {
  return function () {
    var e = t.apply(this, arguments);
    this.textContent = e ?? "";
  };
}
function je() {
  this.innerHTML = "";
}
function Le(t) {
  return function () {
    this.innerHTML = t;
  };
}
function De(t) {
  return function () {
    var e = t.apply(this, arguments);
    this.innerHTML = e ?? "";
  };
}
function Ie() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function Ve() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function Be() {
  return null;
}
function qe() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function Xe() {
  var t = this.cloneNode(!1),
    e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function We() {
  var t = this.cloneNode(!0),
    e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function Ye(t) {
  return function () {
    var e = this.__on;
    if (e) {
      for (var n, r = 0, i = -1, s = e.length; r < s; ++r) n = e[r], t.type && n.type !== t.type || n.name !== t.name ? e[++i] = n : this.removeEventListener(n.type, n.listener, n.options);
      ++i ? e.length = i : delete this.__on;
    }
  };
}
function Fe(t, e, n) {
  return function () {
    var r,
      i = this.__on,
      s = function (t) {
        return function (e) {
          t.call(this, e, this.__data__);
        };
      }(e);
    if (i) for (var o = 0, a = i.length; o < a; ++o) if ((r = i[o]).type === t.type && r.name === t.name) return this.removeEventListener(r.type, r.listener, r.options), this.addEventListener(r.type, r.listener = s, r.options = n), void (r.value = e);
    this.addEventListener(t.type, s, n), r = {
      type: t.type,
      name: t.name,
      value: e,
      listener: s,
      options: n
    }, i ? i.push(r) : this.__on = [r];
  };
}
function Ke(t, e, n) {
  var r = _e(t),
    i = r.CustomEvent;
  "function" == typeof i ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
}
function Ge(t, e) {
  return function () {
    return Ke(this, t, e);
  };
}
function Ze(t, e) {
  return function () {
    return Ke(this, t, e.apply(this, arguments));
  };
}
ae.prototype = {
  constructor: ae,
  appendChild: function (t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function (t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function (t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function (t) {
    return this._parent.querySelectorAll(t);
  }
}, Ne.prototype = {
  add: function (t) {
    this._names.indexOf(t) < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function (t) {
    var e = this._names.indexOf(t);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function (t) {
    return this._names.indexOf(t) >= 0;
  }
};
var Je = [null];
function Qe(t, e) {
  this._groups = t, this._parents = e;
}
function tn() {
  return new Qe([[document.documentElement]], Je);
}
function en(t) {
  return "string" == typeof t ? new Qe([[document.querySelector(t)]], [document.documentElement]) : new Qe([[t]], Je);
}
function nn(t, e) {
  if (t = function (t) {
    let e;
    for (; e = t.sourceEvent;) t = e;
    return t;
  }(t), void 0 === e && (e = t.currentTarget), e) {
    var n = e.ownerSVGElement || e;
    if (n.createSVGPoint) {
      var r = n.createSVGPoint();
      return r.x = t.clientX, r.y = t.clientY, [(r = r.matrixTransform(e.getScreenCTM().inverse())).x, r.y];
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect();
      return [t.clientX - i.left - e.clientLeft, t.clientY - i.top - e.clientTop];
    }
  }
  return [t.pageX, t.pageY];
}
Qe.prototype = tn.prototype = {
  constructor: Qe,
  select: function (t) {
    "function" != typeof t && (t = Gt(t));
    for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) for (var s, o, a = e[i], l = a.length, u = r[i] = new Array(l), h = 0; h < l; ++h) (s = a[h]) && (o = t.call(s, s.__data__, h, a)) && ("__data__" in s && (o.__data__ = s.__data__), u[h] = o);
    return new Qe(r, this._parents);
  },
  selectAll: function (t) {
    t = "function" == typeof t ? Qt(t) : Jt(t);
    for (var e = this._groups, n = e.length, r = [], i = [], s = 0; s < n; ++s) for (var o, a = e[s], l = a.length, u = 0; u < l; ++u) (o = a[u]) && (r.push(t.call(o, o.__data__, u, a)), i.push(o));
    return new Qe(r, i);
  },
  selectChild: function (t) {
    return this.select(null == t ? re : function (t) {
      return function () {
        return ne.call(this.children, t);
      };
    }("function" == typeof t ? t : ee(t)));
  },
  selectChildren: function (t) {
    return this.selectAll(null == t ? se : function (t) {
      return function () {
        return ie.call(this.children, t);
      };
    }("function" == typeof t ? t : ee(t)));
  },
  filter: function (t) {
    "function" != typeof t && (t = te(t));
    for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) for (var s, o = e[i], a = o.length, l = r[i] = [], u = 0; u < a; ++u) (s = o[u]) && t.call(s, s.__data__, u, o) && l.push(s);
    return new Qe(r, this._parents);
  },
  data: function (t, e) {
    if (!arguments.length) return Array.from(this, he);
    var n = e ? ue : le,
      r = this._parents,
      i = this._groups;
    "function" != typeof t && (t = function (t) {
      return function () {
        return t;
      };
    }(t));
    for (var s = i.length, o = new Array(s), a = new Array(s), l = new Array(s), u = 0; u < s; ++u) {
      var h = r[u],
        c = i[u],
        f = c.length,
        d = ce(t.call(h, h && h.__data__, u, r)),
        p = d.length,
        g = a[u] = new Array(p),
        v = o[u] = new Array(p);
      n(h, c, g, v, l[u] = new Array(f), d, e);
      for (var m, y, _ = 0, w = 0; _ < p; ++_) if (m = g[_]) {
        for (_ >= w && (w = _ + 1); !(y = v[w]) && ++w < p;);
        m._next = y || null;
      }
    }
    return (o = new Qe(o, r))._enter = a, o._exit = l, o;
  },
  enter: function () {
    return new Qe(this._enter || this._groups.map(oe), this._parents);
  },
  exit: function () {
    return new Qe(this._exit || this._groups.map(oe), this._parents);
  },
  join: function (t, e, n) {
    var r = this.enter(),
      i = this,
      s = this.exit();
    return "function" == typeof t ? (r = t(r)) && (r = r.selection()) : r = r.append(t + ""), null != e && (i = e(i)) && (i = i.selection()), null == n ? s.remove() : n(s), r && i ? r.merge(i).order() : i;
  },
  merge: function (t) {
    for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, i = n.length, s = r.length, o = Math.min(i, s), a = new Array(i), l = 0; l < o; ++l) for (var u, h = n[l], c = r[l], f = h.length, d = a[l] = new Array(f), p = 0; p < f; ++p) (u = h[p] || c[p]) && (d[p] = u);
    for (; l < i; ++l) a[l] = n[l];
    return new Qe(a, this._parents);
  },
  selection: function () {
    return this;
  },
  order: function () {
    for (var t = this._groups, e = -1, n = t.length; ++e < n;) for (var r, i = t[e], s = i.length - 1, o = i[s]; --s >= 0;) (r = i[s]) && (o && 4 ^ r.compareDocumentPosition(o) && o.parentNode.insertBefore(r, o), o = r);
    return this;
  },
  sort: function (t) {
    function e(e, n) {
      return e && n ? t(e.__data__, n.__data__) : !e - !n;
    }
    t || (t = fe);
    for (var n = this._groups, r = n.length, i = new Array(r), s = 0; s < r; ++s) {
      for (var o, a = n[s], l = a.length, u = i[s] = new Array(l), h = 0; h < l; ++h) (o = a[h]) && (u[h] = o);
      u.sort(e);
    }
    return new Qe(i, this._parents).order();
  },
  call: function () {
    var t = arguments[0];
    return arguments[0] = this, t.apply(null, arguments), this;
  },
  nodes: function () {
    return Array.from(this);
  },
  node: function () {
    for (var t = this._groups, e = 0, n = t.length; e < n; ++e) for (var r = t[e], i = 0, s = r.length; i < s; ++i) {
      var o = r[i];
      if (o) return o;
    }
    return null;
  },
  size: function () {
    let t = 0;
    for (const e of this) ++t;
    return t;
  },
  empty: function () {
    return !this.node();
  },
  each: function (t) {
    for (var e = this._groups, n = 0, r = e.length; n < r; ++n) for (var i, s = e[n], o = 0, a = s.length; o < a; ++o) (i = s[o]) && t.call(i, i.__data__, o, s);
    return this;
  },
  attr: function (t, e) {
    var n = Xt(t);
    if (arguments.length < 2) {
      var r = this.node();
      return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
    }
    return this.each((null == e ? n.local ? pe : de : "function" == typeof e ? n.local ? ye : me : n.local ? ve : ge)(n, e));
  },
  style: function (t, e, n) {
    return arguments.length > 1 ? this.each((null == e ? we : "function" == typeof e ? $e : be)(t, e, n ?? "")) : Ae(this.node(), t);
  },
  property: function (t, e) {
    return arguments.length > 1 ? this.each((null == e ? xe : "function" == typeof e ? Me : Ee)(t, e)) : this.node()[t];
  },
  classed: function (t, e) {
    var n = ke(t + "");
    if (arguments.length < 2) {
      for (var r = Se(this.node()), i = -1, s = n.length; ++i < s;) if (!r.contains(n[i])) return !1;
      return !0;
    }
    return this.each(("function" == typeof e ? Oe : e ? Te : He)(n, e));
  },
  text: function (t) {
    return arguments.length ? this.each(null == t ? Re : ("function" == typeof t ? Ue : ze)(t)) : this.node().textContent;
  },
  html: function (t) {
    return arguments.length ? this.each(null == t ? je : ("function" == typeof t ? De : Le)(t)) : this.node().innerHTML;
  },
  raise: function () {
    return this.each(Ie);
  },
  lower: function () {
    return this.each(Ve);
  },
  append: function (t) {
    var e = "function" == typeof t ? t : Ft(t);
    return this.select(function () {
      return this.appendChild(e.apply(this, arguments));
    });
  },
  insert: function (t, e) {
    var n = "function" == typeof t ? t : Ft(t),
      r = null == e ? Be : "function" == typeof e ? e : Gt(e);
    return this.select(function () {
      return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
    });
  },
  remove: function () {
    return this.each(qe);
  },
  clone: function (t) {
    return this.select(t ? We : Xe);
  },
  datum: function (t) {
    return arguments.length ? this.property("__data__", t) : this.node().__data__;
  },
  on: function (t, e, n) {
    var r,
      i,
      s = function (t) {
        return t.trim().split(/^|\s+/).map(function (t) {
          var e = "",
            n = t.indexOf(".");
          return n >= 0 && (e = t.slice(n + 1), t = t.slice(0, n)), {
            type: t,
            name: e
          };
        });
      }(t + ""),
      o = s.length;
    if (!(arguments.length < 2)) {
      for (a = e ? Fe : Ye, r = 0; r < o; ++r) this.each(a(s[r], e, n));
      return this;
    }
    var a = this.node().__on;
    if (a) for (var l, u = 0, h = a.length; u < h; ++u) for (r = 0, l = a[u]; r < o; ++r) if ((i = s[r]).type === l.type && i.name === l.name) return l.value;
  },
  dispatch: function (t, e) {
    return this.each(("function" == typeof e ? Ze : Ge)(t, e));
  },
  [Symbol.iterator]: function* () {
    for (var t = this._groups, e = 0, n = t.length; e < n; ++e) for (var r, i = t[e], s = 0, o = i.length; s < o; ++s) (r = i[s]) && (yield r);
  }
};
const rn = {
  capture: !0,
  passive: !1
};
function sn(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function on(t, e, n) {
  t.prototype = e.prototype = n, n.constructor = t;
}
function an(t, e) {
  var n = Object.create(t.prototype);
  for (var r in e) n[r] = e[r];
  return n;
}
function ln() {}
var un = .7,
  hn = 1 / un,
  cn = "\\s*([+-]?\\d+)\\s*",
  fn = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*",
  dn = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
  pn = /^#([0-9a-f]{3,8})$/,
  gn = new RegExp(`^rgb\\(${cn},${cn},${cn}\\)$`),
  vn = new RegExp(`^rgb\\(${dn},${dn},${dn}\\)$`),
  mn = new RegExp(`^rgba\\(${cn},${cn},${cn},${fn}\\)$`),
  yn = new RegExp(`^rgba\\(${dn},${dn},${dn},${fn}\\)$`),
  _n = new RegExp(`^hsl\\(${fn},${dn},${dn}\\)$`),
  wn = new RegExp(`^hsla\\(${fn},${dn},${dn},${fn}\\)$`),
  bn = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  };
function $n() {
  return this.rgb().formatHex();
}
function An() {
  return this.rgb().formatRgb();
}
function xn(t) {
  var e, n;
  return t = (t + "").trim().toLowerCase(), (e = pn.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), 6 === n ? En(e) : 3 === n ? new Sn(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : 8 === n ? Mn(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (255 & e) / 255) : 4 === n ? Mn(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, ((15 & e) << 4 | 15 & e) / 255) : null) : (e = gn.exec(t)) ? new Sn(e[1], e[2], e[3], 1) : (e = vn.exec(t)) ? new Sn(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = mn.exec(t)) ? Mn(e[1], e[2], e[3], e[4]) : (e = yn.exec(t)) ? Mn(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = _n.exec(t)) ? On(e[1], e[2] / 100, e[3] / 100, 1) : (e = wn.exec(t)) ? On(e[1], e[2] / 100, e[3] / 100, e[4]) : bn.hasOwnProperty(t) ? En(bn[t]) : "transparent" === t ? new Sn(NaN, NaN, NaN, 0) : null;
}
function En(t) {
  return new Sn(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
}
function Mn(t, e, n, r) {
  return r <= 0 && (t = e = n = NaN), new Sn(t, e, n, r);
}
function kn(t, e, n, r) {
  return 1 === arguments.length ? function (t) {
    return t instanceof ln || (t = xn(t)), t ? new Sn((t = t.rgb()).r, t.g, t.b, t.opacity) : new Sn();
  }(t) : new Sn(t, e, n, r ?? 1);
}
function Sn(t, e, n, r) {
  this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
}
function Nn() {
  return `#${Hn(this.r)}${Hn(this.g)}${Hn(this.b)}`;
}
function Cn() {
  const t = Pn(this.opacity);
  return `${1 === t ? "rgb(" : "rgba("}${Tn(this.r)}, ${Tn(this.g)}, ${Tn(this.b)}${1 === t ? ")" : `, ${t})`}`;
}
function Pn(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function Tn(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function Hn(t) {
  return ((t = Tn(t)) < 16 ? "0" : "") + t.toString(16);
}
function On(t, e, n, r) {
  return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new zn(t, e, n, r);
}
function Rn(t) {
  if (t instanceof zn) return new zn(t.h, t.s, t.l, t.opacity);
  if (t instanceof ln || (t = xn(t)), !t) return new zn();
  if (t instanceof zn) return t;
  var e = (t = t.rgb()).r / 255,
    n = t.g / 255,
    r = t.b / 255,
    i = Math.min(e, n, r),
    s = Math.max(e, n, r),
    o = NaN,
    a = s - i,
    l = (s + i) / 2;
  return a ? (o = e === s ? (n - r) / a + 6 * (n < r) : n === s ? (r - e) / a + 2 : (e - n) / a + 4, a /= l < .5 ? s + i : 2 - s - i, o *= 60) : a = l > 0 && l < 1 ? 0 : o, new zn(o, a, l, t.opacity);
}
function zn(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
function Un(t) {
  return (t = (t || 0) % 360) < 0 ? t + 360 : t;
}
function jn(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function Ln(t, e, n) {
  return 255 * (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e);
}
on(ln, xn, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: $n,
  formatHex: $n,
  formatHex8: function () {
    return this.rgb().formatHex8();
  },
  formatHsl: function () {
    return Rn(this).formatHsl();
  },
  formatRgb: An,
  toString: An
}), on(Sn, kn, an(ln, {
  brighter(t) {
    return t = null == t ? hn : Math.pow(hn, t), new Sn(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = null == t ? un : Math.pow(un, t), new Sn(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Sn(Tn(this.r), Tn(this.g), Tn(this.b), Pn(this.opacity));
  },
  displayable() {
    return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Nn,
  formatHex: Nn,
  formatHex8: function () {
    return `#${Hn(this.r)}${Hn(this.g)}${Hn(this.b)}${Hn(255 * (isNaN(this.opacity) ? 1 : this.opacity))}`;
  },
  formatRgb: Cn,
  toString: Cn
})), on(zn, function (t, e, n, r) {
  return 1 === arguments.length ? Rn(t) : new zn(t, e, n, r ?? 1);
}, an(ln, {
  brighter(t) {
    return t = null == t ? hn : Math.pow(hn, t), new zn(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = null == t ? un : Math.pow(un, t), new zn(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + 360 * (this.h < 0),
      e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
      n = this.l,
      r = n + (n < .5 ? n : 1 - n) * e,
      i = 2 * n - r;
    return new Sn(Ln(t >= 240 ? t - 240 : t + 120, i, r), Ln(t, i, r), Ln(t < 120 ? t + 240 : t - 120, i, r), this.opacity);
  },
  clamp() {
    return new zn(Un(this.h), jn(this.s), jn(this.l), Pn(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = Pn(this.opacity);
    return `${1 === t ? "hsl(" : "hsla("}${Un(this.h)}, ${100 * jn(this.s)}%, ${100 * jn(this.l)}%${1 === t ? ")" : `, ${t})`}`;
  }
}));
var Dn = t => () => t;
function In(t) {
  return 1 == (t = +t) ? Vn : function (e, n) {
    return n - e ? function (t, e, n) {
      return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function (r) {
        return Math.pow(t + r * e, n);
      };
    }(e, n, t) : Dn(isNaN(e) ? n : e);
  };
}
function Vn(t, e) {
  var n = e - t;
  return n ? function (t, e) {
    return function (n) {
      return t + n * e;
    };
  }(t, n) : Dn(isNaN(t) ? e : t);
}
var Bn = function t(e) {
  var n = In(e);
  function r(t, e) {
    var r = n((t = kn(t)).r, (e = kn(e)).r),
      i = n(t.g, e.g),
      s = n(t.b, e.b),
      o = Vn(t.opacity, e.opacity);
    return function (e) {
      return t.r = r(e), t.g = i(e), t.b = s(e), t.opacity = o(e), t + "";
    };
  }
  return r.gamma = t, r;
}(1);
function qn(t, e) {
  e || (e = []);
  var n,
    r = t ? Math.min(e.length, t.length) : 0,
    i = e.slice();
  return function (s) {
    for (n = 0; n < r; ++n) i[n] = t[n] * (1 - s) + e[n] * s;
    return i;
  };
}
function Xn(t, e) {
  var n,
    r = e ? e.length : 0,
    i = t ? Math.min(r, t.length) : 0,
    s = new Array(i),
    o = new Array(r);
  for (n = 0; n < i; ++n) s[n] = Jn(t[n], e[n]);
  for (; n < r; ++n) o[n] = e[n];
  return function (t) {
    for (n = 0; n < i; ++n) o[n] = s[n](t);
    return o;
  };
}
function Wn(t, e) {
  var n = new Date();
  return t = +t, e = +e, function (r) {
    return n.setTime(t * (1 - r) + e * r), n;
  };
}
function Yn(t, e) {
  return t = +t, e = +e, function (n) {
    return t * (1 - n) + e * n;
  };
}
function Fn(t, e) {
  var n,
    r = {},
    i = {};
  for (n in null !== t && "object" == typeof t || (t = {}), null !== e && "object" == typeof e || (e = {}), e) n in t ? r[n] = Jn(t[n], e[n]) : i[n] = e[n];
  return function (t) {
    for (n in r) i[n] = r[n](t);
    return i;
  };
}
var Kn = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
  Gn = new RegExp(Kn.source, "g");
function Zn(t, e) {
  var n,
    r,
    i,
    s = Kn.lastIndex = Gn.lastIndex = 0,
    o = -1,
    a = [],
    l = [];
  for (t += "", e += ""; (n = Kn.exec(t)) && (r = Gn.exec(e));) (i = r.index) > s && (i = e.slice(s, i), a[o] ? a[o] += i : a[++o] = i), (n = n[0]) === (r = r[0]) ? a[o] ? a[o] += r : a[++o] = r : (a[++o] = null, l.push({
    i: o,
    x: Yn(n, r)
  })), s = Gn.lastIndex;
  return s < e.length && (i = e.slice(s), a[o] ? a[o] += i : a[++o] = i), a.length < 2 ? l[0] ? function (t) {
    return function (e) {
      return t(e) + "";
    };
  }(l[0].x) : function (t) {
    return function () {
      return t;
    };
  }(e) : (e = l.length, function (t) {
    for (var n, r = 0; r < e; ++r) a[(n = l[r]).i] = n.x(t);
    return a.join("");
  });
}
function Jn(t, e) {
  var n,
    r = typeof e;
  return null == e || "boolean" === r ? Dn(e) : ("number" === r ? Yn : "string" === r ? (n = xn(e)) ? (e = n, Bn) : Zn : e instanceof xn ? Bn : e instanceof Date ? Wn : function (t) {
    return ArrayBuffer.isView(t) && !(t instanceof DataView);
  }(e) ? qn : Array.isArray(e) ? Xn : "function" != typeof e.valueOf && "function" != typeof e.toString || isNaN(e) ? Fn : Yn)(t, e);
}
function Qn(t, e) {
  return t = +t, e = +e, function (n) {
    return Math.round(t * (1 - n) + e * n);
  };
}
var tr,
  er = 180 / Math.PI,
  nr = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
  };
function rr(t, e, n, r, i, s) {
  var o, a, l;
  return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (l = t * n + e * r) && (n -= t * l, r -= e * l), (a = Math.sqrt(n * n + r * r)) && (n /= a, r /= a, l /= a), t * r < e * n && (t = -t, e = -e, l = -l, o = -o), {
    translateX: i,
    translateY: s,
    rotate: Math.atan2(e, t) * er,
    skewX: Math.atan(l) * er,
    scaleX: o,
    scaleY: a
  };
}
function ir(t, e, n, r) {
  function i(t) {
    return t.length ? t.pop() + " " : "";
  }
  return function (s, o) {
    var a = [],
      l = [];
    return s = t(s), o = t(o), function (t, r, i, s, o, a) {
      if (t !== i || r !== s) {
        var l = o.push("translate(", null, e, null, n);
        a.push({
          i: l - 4,
          x: Yn(t, i)
        }, {
          i: l - 2,
          x: Yn(r, s)
        });
      } else (i || s) && o.push("translate(" + i + e + s + n);
    }(s.translateX, s.translateY, o.translateX, o.translateY, a, l), function (t, e, n, s) {
      t !== e ? (t - e > 180 ? e += 360 : e - t > 180 && (t += 360), s.push({
        i: n.push(i(n) + "rotate(", null, r) - 2,
        x: Yn(t, e)
      })) : e && n.push(i(n) + "rotate(" + e + r);
    }(s.rotate, o.rotate, a, l), function (t, e, n, s) {
      t !== e ? s.push({
        i: n.push(i(n) + "skewX(", null, r) - 2,
        x: Yn(t, e)
      }) : e && n.push(i(n) + "skewX(" + e + r);
    }(s.skewX, o.skewX, a, l), function (t, e, n, r, s, o) {
      if (t !== n || e !== r) {
        var a = s.push(i(s) + "scale(", null, ",", null, ")");
        o.push({
          i: a - 4,
          x: Yn(t, n)
        }, {
          i: a - 2,
          x: Yn(e, r)
        });
      } else 1 === n && 1 === r || s.push(i(s) + "scale(" + n + "," + r + ")");
    }(s.scaleX, s.scaleY, o.scaleX, o.scaleY, a, l), s = o = null, function (t) {
      for (var e, n = -1, r = l.length; ++n < r;) a[(e = l[n]).i] = e.x(t);
      return a.join("");
    };
  };
}
var sr,
  or,
  ar = ir(function (t) {
    const e = new ("function" == typeof DOMMatrix ? DOMMatrix : WebKitCSSMatrix)(t + "");
    return e.isIdentity ? nr : rr(e.a, e.b, e.c, e.d, e.e, e.f);
  }, "px, ", "px)", "deg)"),
  lr = ir(function (t) {
    return null == t ? nr : (tr || (tr = document.createElementNS("http://www.w3.org/2000/svg", "g")), tr.setAttribute("transform", t), (t = tr.transform.baseVal.consolidate()) ? rr((t = t.matrix).a, t.b, t.c, t.d, t.e, t.f) : nr);
  }, ", ", ")", ")"),
  ur = 0,
  hr = 0,
  cr = 0,
  fr = 1e3,
  dr = 0,
  pr = 0,
  gr = 0,
  vr = "object" == typeof performance && performance.now ? performance : Date,
  mr = "object" == typeof window && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (t) {
    setTimeout(t, 17);
  };
function yr() {
  return pr || (mr(_r), pr = vr.now() + gr);
}
function _r() {
  pr = 0;
}
function wr() {
  this._call = this._time = this._next = null;
}
function br(t, e, n) {
  var r = new wr();
  return r.restart(t, e, n), r;
}
function $r() {
  pr = (dr = vr.now()) + gr, ur = hr = 0;
  try {
    !function () {
      yr(), ++ur;
      for (var t, e = sr; e;) (t = pr - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
      --ur;
    }();
  } finally {
    ur = 0, function () {
      var t,
        e,
        n = sr,
        r = 1 / 0;
      for (; n;) n._call ? (r > n._time && (r = n._time), t = n, n = n._next) : (e = n._next, n._next = null, n = t ? t._next = e : sr = e);
      or = t, xr(r);
    }(), pr = 0;
  }
}
function Ar() {
  var t = vr.now(),
    e = t - dr;
  e > fr && (gr -= e, dr = t);
}
function xr(t) {
  ur || (hr && (hr = clearTimeout(hr)), t - pr > 24 ? (t < 1 / 0 && (hr = setTimeout($r, t - vr.now() - gr)), cr && (cr = clearInterval(cr))) : (cr || (dr = vr.now(), cr = setInterval(Ar, fr)), ur = 1, mr($r)));
}
function Er(t, e, n) {
  var r = new wr();
  return e = null == e ? 0 : +e, r.restart(n => {
    r.stop(), t(n + e);
  }, e, n), r;
}
wr.prototype = br.prototype = {
  constructor: wr,
  restart: function (t, e, n) {
    if ("function" != typeof t) throw new TypeError("callback is not a function");
    n = (null == n ? yr() : +n) + (null == e ? 0 : +e), this._next || or === this || (or ? or._next = this : sr = this, or = this), this._call = t, this._time = n, xr();
  },
  stop: function () {
    this._call && (this._call = null, this._time = 1 / 0, xr());
  }
};
var Mr = Lt("start", "end", "cancel", "interrupt"),
  kr = [],
  Sr = 0,
  Nr = 1,
  Cr = 2,
  Pr = 3,
  Tr = 4,
  Hr = 5,
  Or = 6;
function Rr(t, e, n, r, i, s) {
  var o = t.__transition;
  if (o) {
    if (n in o) return;
  } else t.__transition = {};
  !function (t, e, n) {
    var r,
      i = t.__transition;
    function s(t) {
      n.state = Nr, n.timer.restart(o, n.delay, n.time), n.delay <= t && o(t - n.delay);
    }
    function o(s) {
      var u, h, c, f;
      if (n.state !== Nr) return l();
      for (u in i) if ((f = i[u]).name === n.name) {
        if (f.state === Pr) return Er(o);
        f.state === Tr ? (f.state = Or, f.timer.stop(), f.on.call("interrupt", t, t.__data__, f.index, f.group), delete i[u]) : +u < e && (f.state = Or, f.timer.stop(), f.on.call("cancel", t, t.__data__, f.index, f.group), delete i[u]);
      }
      if (Er(function () {
        n.state === Pr && (n.state = Tr, n.timer.restart(a, n.delay, n.time), a(s));
      }), n.state = Cr, n.on.call("start", t, t.__data__, n.index, n.group), n.state === Cr) {
        for (n.state = Pr, r = new Array(c = n.tween.length), u = 0, h = -1; u < c; ++u) (f = n.tween[u].value.call(t, t.__data__, n.index, n.group)) && (r[++h] = f);
        r.length = h + 1;
      }
    }
    function a(e) {
      for (var i = e < n.duration ? n.ease.call(null, e / n.duration) : (n.timer.restart(l), n.state = Hr, 1), s = -1, o = r.length; ++s < o;) r[s].call(t, i);
      n.state === Hr && (n.on.call("end", t, t.__data__, n.index, n.group), l());
    }
    function l() {
      for (var r in n.state = Or, n.timer.stop(), delete i[e], i) return;
      delete t.__transition;
    }
    i[e] = n, n.timer = br(s, 0, n.time);
  }(t, n, {
    name: e,
    index: r,
    group: i,
    on: Mr,
    tween: kr,
    time: s.time,
    delay: s.delay,
    duration: s.duration,
    ease: s.ease,
    timer: null,
    state: Sr
  });
}
function zr(t, e) {
  var n = jr(t, e);
  if (n.state > Sr) throw new Error("too late; already scheduled");
  return n;
}
function Ur(t, e) {
  var n = jr(t, e);
  if (n.state > Pr) throw new Error("too late; already running");
  return n;
}
function jr(t, e) {
  var n = t.__transition;
  if (!n || !(n = n[e])) throw new Error("transition not found");
  return n;
}
function Lr(t, e) {
  var n,
    r,
    i,
    s = t.__transition,
    o = !0;
  if (s) {
    for (i in e = null == e ? null : e + "", s) (n = s[i]).name === e ? (r = n.state > Cr && n.state < Hr, n.state = Or, n.timer.stop(), n.on.call(r ? "interrupt" : "cancel", t, t.__data__, n.index, n.group), delete s[i]) : o = !1;
    o && delete t.__transition;
  }
}
function Dr(t, e) {
  var n, r;
  return function () {
    var i = Ur(this, t),
      s = i.tween;
    if (s !== n) for (var o = 0, a = (r = n = s).length; o < a; ++o) if (r[o].name === e) {
      (r = r.slice()).splice(o, 1);
      break;
    }
    i.tween = r;
  };
}
function Ir(t, e, n) {
  var r, i;
  if ("function" != typeof n) throw new Error();
  return function () {
    var s = Ur(this, t),
      o = s.tween;
    if (o !== r) {
      i = (r = o).slice();
      for (var a = {
          name: e,
          value: n
        }, l = 0, u = i.length; l < u; ++l) if (i[l].name === e) {
        i[l] = a;
        break;
      }
      l === u && i.push(a);
    }
    s.tween = i;
  };
}
function Vr(t, e, n) {
  var r = t._id;
  return t.each(function () {
    var t = Ur(this, r);
    (t.value || (t.value = {}))[e] = n.apply(this, arguments);
  }), function (t) {
    return jr(t, r).value[e];
  };
}
function Br(t, e) {
  var n;
  return ("number" == typeof e ? Yn : e instanceof xn ? Bn : (n = xn(e)) ? (e = n, Bn) : Zn)(t, e);
}
function qr(t) {
  return function () {
    this.removeAttribute(t);
  };
}
function Xr(t) {
  return function () {
    this.removeAttributeNS(t.space, t.local);
  };
}
function Wr(t, e, n) {
  var r,
    i,
    s = n + "";
  return function () {
    var o = this.getAttribute(t);
    return o === s ? null : o === r ? i : i = e(r = o, n);
  };
}
function Yr(t, e, n) {
  var r,
    i,
    s = n + "";
  return function () {
    var o = this.getAttributeNS(t.space, t.local);
    return o === s ? null : o === r ? i : i = e(r = o, n);
  };
}
function Fr(t, e, n) {
  var r, i, s;
  return function () {
    var o,
      a,
      l = n(this);
    if (null != l) return (o = this.getAttribute(t)) === (a = l + "") ? null : o === r && a === i ? s : (i = a, s = e(r = o, l));
    this.removeAttribute(t);
  };
}
function Kr(t, e, n) {
  var r, i, s;
  return function () {
    var o,
      a,
      l = n(this);
    if (null != l) return (o = this.getAttributeNS(t.space, t.local)) === (a = l + "") ? null : o === r && a === i ? s : (i = a, s = e(r = o, l));
    this.removeAttributeNS(t.space, t.local);
  };
}
function Gr(t, e) {
  var n, r;
  function i() {
    var i = e.apply(this, arguments);
    return i !== r && (n = (r = i) && function (t, e) {
      return function (n) {
        this.setAttributeNS(t.space, t.local, e.call(this, n));
      };
    }(t, i)), n;
  }
  return i._value = e, i;
}
function Zr(t, e) {
  var n, r;
  function i() {
    var i = e.apply(this, arguments);
    return i !== r && (n = (r = i) && function (t, e) {
      return function (n) {
        this.setAttribute(t, e.call(this, n));
      };
    }(t, i)), n;
  }
  return i._value = e, i;
}
function Jr(t, e) {
  return function () {
    zr(this, t).delay = +e.apply(this, arguments);
  };
}
function Qr(t, e) {
  return e = +e, function () {
    zr(this, t).delay = e;
  };
}
function ti(t, e) {
  return function () {
    Ur(this, t).duration = +e.apply(this, arguments);
  };
}
function ei(t, e) {
  return e = +e, function () {
    Ur(this, t).duration = e;
  };
}
var ni = tn.prototype.constructor;
function ri(t) {
  return function () {
    this.style.removeProperty(t);
  };
}
var ii = 0;
function si(t, e, n, r) {
  this._groups = t, this._parents = e, this._name = n, this._id = r;
}
function oi() {
  return ++ii;
}
var ai = tn.prototype;
si.prototype = {
  constructor: si,
  select: function (t) {
    var e = this._name,
      n = this._id;
    "function" != typeof t && (t = Gt(t));
    for (var r = this._groups, i = r.length, s = new Array(i), o = 0; o < i; ++o) for (var a, l, u = r[o], h = u.length, c = s[o] = new Array(h), f = 0; f < h; ++f) (a = u[f]) && (l = t.call(a, a.__data__, f, u)) && ("__data__" in a && (l.__data__ = a.__data__), c[f] = l, Rr(c[f], e, n, f, c, jr(a, n)));
    return new si(s, this._parents, e, n);
  },
  selectAll: function (t) {
    var e = this._name,
      n = this._id;
    "function" != typeof t && (t = Jt(t));
    for (var r = this._groups, i = r.length, s = [], o = [], a = 0; a < i; ++a) for (var l, u = r[a], h = u.length, c = 0; c < h; ++c) if (l = u[c]) {
      for (var f, d = t.call(l, l.__data__, c, u), p = jr(l, n), g = 0, v = d.length; g < v; ++g) (f = d[g]) && Rr(f, e, n, g, d, p);
      s.push(d), o.push(l);
    }
    return new si(s, o, e, n);
  },
  selectChild: ai.selectChild,
  selectChildren: ai.selectChildren,
  filter: function (t) {
    "function" != typeof t && (t = te(t));
    for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) for (var s, o = e[i], a = o.length, l = r[i] = [], u = 0; u < a; ++u) (s = o[u]) && t.call(s, s.__data__, u, o) && l.push(s);
    return new si(r, this._parents, this._name, this._id);
  },
  merge: function (t) {
    if (t._id !== this._id) throw new Error();
    for (var e = this._groups, n = t._groups, r = e.length, i = n.length, s = Math.min(r, i), o = new Array(r), a = 0; a < s; ++a) for (var l, u = e[a], h = n[a], c = u.length, f = o[a] = new Array(c), d = 0; d < c; ++d) (l = u[d] || h[d]) && (f[d] = l);
    for (; a < r; ++a) o[a] = e[a];
    return new si(o, this._parents, this._name, this._id);
  },
  selection: function () {
    return new ni(this._groups, this._parents);
  },
  transition: function () {
    for (var t = this._name, e = this._id, n = oi(), r = this._groups, i = r.length, s = 0; s < i; ++s) for (var o, a = r[s], l = a.length, u = 0; u < l; ++u) if (o = a[u]) {
      var h = jr(o, e);
      Rr(o, t, n, u, a, {
        time: h.time + h.delay + h.duration,
        delay: 0,
        duration: h.duration,
        ease: h.ease
      });
    }
    return new si(r, this._parents, t, n);
  },
  call: ai.call,
  nodes: ai.nodes,
  node: ai.node,
  size: ai.size,
  empty: ai.empty,
  each: ai.each,
  on: function (t, e) {
    var n = this._id;
    return arguments.length < 2 ? jr(this.node(), n).on.on(t) : this.each(function (t, e, n) {
      var r,
        i,
        s = function (t) {
          return (t + "").trim().split(/^|\s+/).every(function (t) {
            var e = t.indexOf(".");
            return e >= 0 && (t = t.slice(0, e)), !t || "start" === t;
          });
        }(e) ? zr : Ur;
      return function () {
        var o = s(this, t),
          a = o.on;
        a !== r && (i = (r = a).copy()).on(e, n), o.on = i;
      };
    }(n, t, e));
  },
  attr: function (t, e) {
    var n = Xt(t),
      r = "transform" === n ? lr : Br;
    return this.attrTween(t, "function" == typeof e ? (n.local ? Kr : Fr)(n, r, Vr(this, "attr." + t, e)) : null == e ? (n.local ? Xr : qr)(n) : (n.local ? Yr : Wr)(n, r, e));
  },
  attrTween: function (t, e) {
    var n = "attr." + t;
    if (arguments.length < 2) return (n = this.tween(n)) && n._value;
    if (null == e) return this.tween(n, null);
    if ("function" != typeof e) throw new Error();
    var r = Xt(t);
    return this.tween(n, (r.local ? Gr : Zr)(r, e));
  },
  style: function (t, e, n) {
    var r = "transform" == (t += "") ? ar : Br;
    return null == e ? this.styleTween(t, function (t, e) {
      var n, r, i;
      return function () {
        var s = Ae(this, t),
          o = (this.style.removeProperty(t), Ae(this, t));
        return s === o ? null : s === n && o === r ? i : i = e(n = s, r = o);
      };
    }(t, r)).on("end.style." + t, ri(t)) : "function" == typeof e ? this.styleTween(t, function (t, e, n) {
      var r, i, s;
      return function () {
        var o = Ae(this, t),
          a = n(this),
          l = a + "";
        return null == a && (this.style.removeProperty(t), l = a = Ae(this, t)), o === l ? null : o === r && l === i ? s : (i = l, s = e(r = o, a));
      };
    }(t, r, Vr(this, "style." + t, e))).each(function (t, e) {
      var n,
        r,
        i,
        s,
        o = "style." + e,
        a = "end." + o;
      return function () {
        var l = Ur(this, t),
          u = l.on,
          h = null == l.value[o] ? s || (s = ri(e)) : void 0;
        u === n && i === h || (r = (n = u).copy()).on(a, i = h), l.on = r;
      };
    }(this._id, t)) : this.styleTween(t, function (t, e, n) {
      var r,
        i,
        s = n + "";
      return function () {
        var o = Ae(this, t);
        return o === s ? null : o === r ? i : i = e(r = o, n);
      };
    }(t, r, e), n).on("end.style." + t, null);
  },
  styleTween: function (t, e, n) {
    var r = "style." + (t += "");
    if (arguments.length < 2) return (r = this.tween(r)) && r._value;
    if (null == e) return this.tween(r, null);
    if ("function" != typeof e) throw new Error();
    return this.tween(r, function (t, e, n) {
      var r, i;
      function s() {
        var s = e.apply(this, arguments);
        return s !== i && (r = (i = s) && function (t, e, n) {
          return function (r) {
            this.style.setProperty(t, e.call(this, r), n);
          };
        }(t, s, n)), r;
      }
      return s._value = e, s;
    }(t, e, n ?? ""));
  },
  text: function (t) {
    return this.tween("text", "function" == typeof t ? function (t) {
      return function () {
        var e = t(this);
        this.textContent = e ?? "";
      };
    }(Vr(this, "text", t)) : function (t) {
      return function () {
        this.textContent = t;
      };
    }(null == t ? "" : t + ""));
  },
  textTween: function (t) {
    var e = "text";
    if (arguments.length < 1) return (e = this.tween(e)) && e._value;
    if (null == t) return this.tween(e, null);
    if ("function" != typeof t) throw new Error();
    return this.tween(e, function (t) {
      var e, n;
      function r() {
        var r = t.apply(this, arguments);
        return r !== n && (e = (n = r) && function (t) {
          return function (e) {
            this.textContent = t.call(this, e);
          };
        }(r)), e;
      }
      return r._value = t, r;
    }(t));
  },
  remove: function () {
    return this.on("end.remove", function (t) {
      return function () {
        var e = this.parentNode;
        for (var n in this.__transition) if (+n !== t) return;
        e && e.removeChild(this);
      };
    }(this._id));
  },
  tween: function (t, e) {
    var n = this._id;
    if (t += "", arguments.length < 2) {
      for (var r, i = jr(this.node(), n).tween, s = 0, o = i.length; s < o; ++s) if ((r = i[s]).name === t) return r.value;
      return null;
    }
    return this.each((null == e ? Dr : Ir)(n, t, e));
  },
  delay: function (t) {
    var e = this._id;
    return arguments.length ? this.each(("function" == typeof t ? Jr : Qr)(e, t)) : jr(this.node(), e).delay;
  },
  duration: function (t) {
    var e = this._id;
    return arguments.length ? this.each(("function" == typeof t ? ti : ei)(e, t)) : jr(this.node(), e).duration;
  },
  ease: function (t) {
    var e = this._id;
    return arguments.length ? this.each(function (t, e) {
      if ("function" != typeof e) throw new Error();
      return function () {
        Ur(this, t).ease = e;
      };
    }(e, t)) : jr(this.node(), e).ease;
  },
  easeVarying: function (t) {
    if ("function" != typeof t) throw new Error();
    return this.each(function (t, e) {
      return function () {
        var n = e.apply(this, arguments);
        if ("function" != typeof n) throw new Error();
        Ur(this, t).ease = n;
      };
    }(this._id, t));
  },
  end: function () {
    var t,
      e,
      n = this,
      r = n._id,
      i = n.size();
    return new Promise(function (s, o) {
      var a = {
          value: o
        },
        l = {
          value: function () {
            0 == --i && s();
          }
        };
      n.each(function () {
        var n = Ur(this, r),
          i = n.on;
        i !== t && ((e = (t = i).copy())._.cancel.push(a), e._.interrupt.push(a), e._.end.push(l)), n.on = e;
      }), 0 === i && s();
    });
  },
  [Symbol.iterator]: ai[Symbol.iterator]
};
var li = {
  time: null,
  delay: 0,
  duration: 250,
  ease: function (t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
  }
};
function ui(t, e) {
  for (var n; !(n = t.__transition) || !(n = n[e]);) if (!(t = t.parentNode)) throw new Error(`transition ${e} not found`);
  return n;
}
tn.prototype.interrupt = function (t) {
  return this.each(function () {
    Lr(this, t);
  });
}, tn.prototype.transition = function (t) {
  var e, n;
  t instanceof si ? (e = t._id, t = t._name) : (e = oi(), (n = li).time = yr(), t = null == t ? null : t + "");
  for (var r = this._groups, i = r.length, s = 0; s < i; ++s) for (var o, a = r[s], l = a.length, u = 0; u < l; ++u) (o = a[u]) && Rr(o, t, e, u, a, n || ui(o, e));
  return new si(r, this._parents, t, e);
};
var hi = t => () => t;
function ci(t, {
  sourceEvent: e,
  target: n,
  selection: r,
  mode: i,
  dispatch: s
}) {
  Object.defineProperties(this, {
    type: {
      value: t,
      enumerable: !0,
      configurable: !0
    },
    sourceEvent: {
      value: e,
      enumerable: !0,
      configurable: !0
    },
    target: {
      value: n,
      enumerable: !0,
      configurable: !0
    },
    selection: {
      value: r,
      enumerable: !0,
      configurable: !0
    },
    mode: {
      value: i,
      enumerable: !0,
      configurable: !0
    },
    _: {
      value: s
    }
  });
}
function fi(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
var di = {
    name: "drag"
  },
  pi = {
    name: "space"
  },
  gi = {
    name: "handle"
  },
  vi = {
    name: "center"
  };
const {
  abs: mi,
  max: yi,
  min: _i
} = Math;
function wi(t) {
  return [+t[0], +t[1]];
}
function bi(t) {
  return [wi(t[0]), wi(t[1])];
}
var $i = {
    name: "x",
    handles: ["w", "e"].map(Ni),
    input: function (t, e) {
      return null == t ? null : [[+t[0], e[0][1]], [+t[1], e[1][1]]];
    },
    output: function (t) {
      return t && [t[0][0], t[1][0]];
    }
  },
  Ai = {
    name: "y",
    handles: ["n", "s"].map(Ni),
    input: function (t, e) {
      return null == t ? null : [[e[0][0], +t[0]], [e[1][0], +t[1]]];
    },
    output: function (t) {
      return t && [t[0][1], t[1][1]];
    }
  },
  xi = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
  },
  Ei = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
  },
  Mi = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
  },
  ki = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
  },
  Si = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
  };
function Ni(t) {
  return {
    type: t
  };
}
function Ci(t) {
  return !t.ctrlKey && !t.button;
}
function Pi() {
  var t = this.ownerSVGElement || this;
  return t.hasAttribute("viewBox") ? [[(t = t.viewBox.baseVal).x, t.y], [t.x + t.width, t.y + t.height]] : [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]];
}
function Ti() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function Hi(t) {
  for (; !t.__brush;) if (!(t = t.parentNode)) return;
  return t.__brush;
}
function Oi() {
  return function (t) {
    var e,
      n = Pi,
      r = Ci,
      i = Ti,
      s = !0,
      o = Lt("start", "brush", "end"),
      a = 6;
    function l(e) {
      var n = e.property("__brush", g).selectAll(".overlay").data([Ni("overlay")]);
      n.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", xi.overlay).merge(n).each(function () {
        var t = Hi(this).extent;
        en(this).attr("x", t[0][0]).attr("y", t[0][1]).attr("width", t[1][0] - t[0][0]).attr("height", t[1][1] - t[0][1]);
      }), e.selectAll(".selection").data([Ni("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", xi.selection).attr("fill", "#777").attr("fill-opacity", .3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
      var r = e.selectAll(".handle").data(t.handles, function (t) {
        return t.type;
      });
      r.exit().remove(), r.enter().append("rect").attr("class", function (t) {
        return "handle handle--" + t.type;
      }).attr("cursor", function (t) {
        return xi[t.type];
      }), e.each(u).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", f).filter(i).on("touchstart.brush", f).on("touchmove.brush", d).on("touchend.brush touchcancel.brush", p).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    function u() {
      var t = en(this),
        e = Hi(this).selection;
      e ? (t.selectAll(".selection").style("display", null).attr("x", e[0][0]).attr("y", e[0][1]).attr("width", e[1][0] - e[0][0]).attr("height", e[1][1] - e[0][1]), t.selectAll(".handle").style("display", null).attr("x", function (t) {
        return "e" === t.type[t.type.length - 1] ? e[1][0] - a / 2 : e[0][0] - a / 2;
      }).attr("y", function (t) {
        return "s" === t.type[0] ? e[1][1] - a / 2 : e[0][1] - a / 2;
      }).attr("width", function (t) {
        return "n" === t.type || "s" === t.type ? e[1][0] - e[0][0] + a : a;
      }).attr("height", function (t) {
        return "e" === t.type || "w" === t.type ? e[1][1] - e[0][1] + a : a;
      })) : t.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function h(t, e, n) {
      var r = t.__brush.emitter;
      return !r || n && r.clean ? new c(t, e, n) : r;
    }
    function c(t, e, n) {
      this.that = t, this.args = e, this.state = t.__brush, this.active = 0, this.clean = n;
    }
    function f(n) {
      if ((!e || n.touches) && r.apply(this, arguments)) {
        var i,
          o,
          a,
          l,
          c,
          f,
          d,
          p,
          g,
          v,
          m,
          y = this,
          _ = n.target.__data__.type,
          w = "selection" === (s && n.metaKey ? _ = "overlay" : _) ? di : s && n.altKey ? vi : gi,
          b = t === Ai ? null : ki[_],
          $ = t === $i ? null : Si[_],
          A = Hi(y),
          x = A.extent,
          E = A.selection,
          M = x[0][0],
          k = x[0][1],
          S = x[1][0],
          N = x[1][1],
          C = 0,
          P = 0,
          T = b && $ && s && n.shiftKey,
          H = Array.from(n.touches || [n], t => {
            const e = t.identifier;
            return (t = nn(t, y)).point0 = t.slice(), t.identifier = e, t;
          });
        Lr(y);
        var O = h(y, arguments, !0).beforestart();
        if ("overlay" === _) {
          E && (g = !0);
          const e = [H[0], H[1] || H[0]];
          A.selection = E = [[i = t === Ai ? M : _i(e[0][0], e[1][0]), a = t === $i ? k : _i(e[0][1], e[1][1])], [c = t === Ai ? S : yi(e[0][0], e[1][0]), d = t === $i ? N : yi(e[0][1], e[1][1])]], H.length > 1 && L(n);
        } else i = E[0][0], a = E[0][1], c = E[1][0], d = E[1][1];
        o = i, l = a, f = c, p = d;
        var R = en(y).attr("pointer-events", "none"),
          z = R.selectAll(".overlay").attr("cursor", xi[_]);
        if (n.touches) O.moved = j, O.ended = D;else {
          var U = en(n.view).on("mousemove.brush", j, !0).on("mouseup.brush", D, !0);
          s && U.on("keydown.brush", I, !0).on("keyup.brush", V, !0), function (t) {
            var e = t.document.documentElement,
              n = en(t).on("dragstart.drag", sn, rn);
            "onselectstart" in e ? n.on("selectstart.drag", sn, rn) : (e.__noselect = e.style.MozUserSelect, e.style.MozUserSelect = "none");
          }(n.view);
        }
        u.call(y), O.start(n, w.name);
      }
      function j(t) {
        for (const e of t.changedTouches || [t]) for (const t of H) t.identifier === e.identifier && (t.cur = nn(e, y));
        if (T && !v && !m && 1 === H.length) {
          const t = H[0];
          mi(t.cur[0] - t[0]) > mi(t.cur[1] - t[1]) ? m = !0 : v = !0;
        }
        for (const t of H) t.cur && (t[0] = t.cur[0], t[1] = t.cur[1]);
        g = !0, fi(t), L(t);
      }
      function L(t) {
        const e = H[0],
          n = e.point0;
        var r;
        switch (C = e[0] - n[0], P = e[1] - n[1], w) {
          case pi:
          case di:
            b && (C = yi(M - i, _i(S - c, C)), o = i + C, f = c + C), $ && (P = yi(k - a, _i(N - d, P)), l = a + P, p = d + P);
            break;
          case gi:
            H[1] ? (b && (o = yi(M, _i(S, H[0][0])), f = yi(M, _i(S, H[1][0])), b = 1), $ && (l = yi(k, _i(N, H[0][1])), p = yi(k, _i(N, H[1][1])), $ = 1)) : (b < 0 ? (C = yi(M - i, _i(S - i, C)), o = i + C, f = c) : b > 0 && (C = yi(M - c, _i(S - c, C)), o = i, f = c + C), $ < 0 ? (P = yi(k - a, _i(N - a, P)), l = a + P, p = d) : $ > 0 && (P = yi(k - d, _i(N - d, P)), l = a, p = d + P));
            break;
          case vi:
            b && (o = yi(M, _i(S, i - C * b)), f = yi(M, _i(S, c + C * b))), $ && (l = yi(k, _i(N, a - P * $)), p = yi(k, _i(N, d + P * $)));
        }
        f < o && (b *= -1, r = i, i = c, c = r, r = o, o = f, f = r, _ in Ei && z.attr("cursor", xi[_ = Ei[_]])), p < l && ($ *= -1, r = a, a = d, d = r, r = l, l = p, p = r, _ in Mi && z.attr("cursor", xi[_ = Mi[_]])), A.selection && (E = A.selection), v && (o = E[0][0], f = E[1][0]), m && (l = E[0][1], p = E[1][1]), E[0][0] === o && E[0][1] === l && E[1][0] === f && E[1][1] === p || (A.selection = [[o, l], [f, p]], u.call(y), O.brush(t, w.name));
      }
      function D(t) {
        if (function (t) {
          t.stopImmediatePropagation();
        }(t), t.touches) {
          if (t.touches.length) return;
          e && clearTimeout(e), e = setTimeout(function () {
            e = null;
          }, 500);
        } else !function (t, e) {
          var n = t.document.documentElement,
            r = en(t).on("dragstart.drag", null);
          e && (r.on("click.drag", sn, rn), setTimeout(function () {
            r.on("click.drag", null);
          }, 0)), "onselectstart" in n ? r.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
        }(t.view, g), U.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
        R.attr("pointer-events", "all"), z.attr("cursor", xi.overlay), A.selection && (E = A.selection), function (t) {
          return t[0][0] === t[1][0] || t[0][1] === t[1][1];
        }(E) && (A.selection = null, u.call(y)), O.end(t, w.name);
      }
      function I(t) {
        switch (t.keyCode) {
          case 16:
            T = b && $;
            break;
          case 18:
            w === gi && (b && (c = f - C * b, i = o + C * b), $ && (d = p - P * $, a = l + P * $), w = vi, L(t));
            break;
          case 32:
            w !== gi && w !== vi || (b < 0 ? c = f - C : b > 0 && (i = o - C), $ < 0 ? d = p - P : $ > 0 && (a = l - P), w = pi, z.attr("cursor", xi.selection), L(t));
            break;
          default:
            return;
        }
        fi(t);
      }
      function V(t) {
        switch (t.keyCode) {
          case 16:
            T && (v = m = T = !1, L(t));
            break;
          case 18:
            w === vi && (b < 0 ? c = f : b > 0 && (i = o), $ < 0 ? d = p : $ > 0 && (a = l), w = gi, L(t));
            break;
          case 32:
            w === pi && (t.altKey ? (b && (c = f - C * b, i = o + C * b), $ && (d = p - P * $, a = l + P * $), w = vi) : (b < 0 ? c = f : b > 0 && (i = o), $ < 0 ? d = p : $ > 0 && (a = l), w = gi), z.attr("cursor", xi[_]), L(t));
            break;
          default:
            return;
        }
        fi(t);
      }
    }
    function d(t) {
      h(this, arguments).moved(t);
    }
    function p(t) {
      h(this, arguments).ended(t);
    }
    function g() {
      var e = this.__brush || {
        selection: null
      };
      return e.extent = bi(n.apply(this, arguments)), e.dim = t, e;
    }
    return l.move = function (e, n, r) {
      e.tween ? e.on("start.brush", function (t) {
        h(this, arguments).beforestart().start(t);
      }).on("interrupt.brush end.brush", function (t) {
        h(this, arguments).end(t);
      }).tween("brush", function () {
        var e = this,
          r = e.__brush,
          i = h(e, arguments),
          s = r.selection,
          o = t.input("function" == typeof n ? n.apply(this, arguments) : n, r.extent),
          a = Jn(s, o);
        function l(t) {
          r.selection = 1 === t && null === o ? null : a(t), u.call(e), i.brush();
        }
        return null !== s && null !== o ? l : l(1);
      }) : e.each(function () {
        var e = this,
          i = arguments,
          s = e.__brush,
          o = t.input("function" == typeof n ? n.apply(e, i) : n, s.extent),
          a = h(e, i).beforestart();
        Lr(e), s.selection = null === o ? null : o, u.call(e), a.start(r).brush(r).end(r);
      });
    }, l.clear = function (t, e) {
      l.move(t, null, e);
    }, c.prototype = {
      beforestart: function () {
        return 1 == ++this.active && (this.state.emitter = this, this.starting = !0), this;
      },
      start: function (t, e) {
        return this.starting ? (this.starting = !1, this.emit("start", t, e)) : this.emit("brush", t), this;
      },
      brush: function (t, e) {
        return this.emit("brush", t, e), this;
      },
      end: function (t, e) {
        return 0 == --this.active && (delete this.state.emitter, this.emit("end", t, e)), this;
      },
      emit: function (e, n, r) {
        var i = en(this.that).datum();
        o.call(e, this.that, new ci(e, {
          sourceEvent: n,
          target: l,
          selection: t.output(this.state.selection),
          mode: r,
          dispatch: o
        }), i);
      }
    }, l.extent = function (t) {
      return arguments.length ? (n = "function" == typeof t ? t : hi(bi(t)), l) : n;
    }, l.filter = function (t) {
      return arguments.length ? (r = "function" == typeof t ? t : hi(!!t), l) : r;
    }, l.touchable = function (t) {
      return arguments.length ? (i = "function" == typeof t ? t : hi(!!t), l) : i;
    }, l.handleSize = function (t) {
      return arguments.length ? (a = +t, l) : a;
    }, l.keyModifiers = function (t) {
      return arguments.length ? (s = !!t, l) : s;
    }, l.on = function () {
      var t = o.on.apply(o, arguments);
      return t === o ? l : t;
    }, l;
  }($i);
}
function Ri(t, e) {
  if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
  var n,
    r = t.slice(0, n);
  return [r.length > 1 ? r[0] + r.slice(2) : r, +t.slice(n + 1)];
}
function zi(t) {
  return (t = Ri(Math.abs(t))) ? t[1] : NaN;
}
var Ui,
  ji = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Li(t) {
  if (!(e = ji.exec(t))) throw new Error("invalid format: " + t);
  var e;
  return new Di({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
function Di(t) {
  this.fill = void 0 === t.fill ? " " : t.fill + "", this.align = void 0 === t.align ? ">" : t.align + "", this.sign = void 0 === t.sign ? "-" : t.sign + "", this.symbol = void 0 === t.symbol ? "" : t.symbol + "", this.zero = !!t.zero, this.width = void 0 === t.width ? void 0 : +t.width, this.comma = !!t.comma, this.precision = void 0 === t.precision ? void 0 : +t.precision, this.trim = !!t.trim, this.type = void 0 === t.type ? "" : t.type + "";
}
function Ii(t, e) {
  var n = Ri(t, e);
  if (!n) return t + "";
  var r = n[0],
    i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
Li.prototype = Di.prototype, Di.prototype.toString = function () {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
};
var Vi = {
  "%": (t, e) => (100 * t).toFixed(e),
  b: t => Math.round(t).toString(2),
  c: t => t + "",
  d: function (t) {
    return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
  },
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: t => Math.round(t).toString(8),
  p: (t, e) => Ii(100 * t, e),
  r: Ii,
  s: function (t, e) {
    var n = Ri(t, e);
    if (!n) return t + "";
    var r = n[0],
      i = n[1],
      s = i - (Ui = 3 * Math.max(-8, Math.min(8, Math.floor(i / 3)))) + 1,
      o = r.length;
    return s === o ? r : s > o ? r + new Array(s - o + 1).join("0") : s > 0 ? r.slice(0, s) + "." + r.slice(s) : "0." + new Array(1 - s).join("0") + Ri(t, Math.max(0, e + s - 1))[0];
  },
  X: t => Math.round(t).toString(16).toUpperCase(),
  x: t => Math.round(t).toString(16)
};
function Bi(t) {
  return t;
}
var qi,
  Xi,
  Wi,
  Yi = Array.prototype.map,
  Fi = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function Ki(t) {
  var e,
    n,
    r = void 0 === t.grouping || void 0 === t.thousands ? Bi : (e = Yi.call(t.grouping, Number), n = t.thousands + "", function (t, r) {
      for (var i = t.length, s = [], o = 0, a = e[0], l = 0; i > 0 && a > 0 && (l + a + 1 > r && (a = Math.max(1, r - l)), s.push(t.substring(i -= a, i + a)), !((l += a + 1) > r));) a = e[o = (o + 1) % e.length];
      return s.reverse().join(n);
    }),
    i = void 0 === t.currency ? "" : t.currency[0] + "",
    s = void 0 === t.currency ? "" : t.currency[1] + "",
    o = void 0 === t.decimal ? "." : t.decimal + "",
    a = void 0 === t.numerals ? Bi : function (t) {
      return function (e) {
        return e.replace(/[0-9]/g, function (e) {
          return t[+e];
        });
      };
    }(Yi.call(t.numerals, String)),
    l = void 0 === t.percent ? "%" : t.percent + "",
    u = void 0 === t.minus ? "−" : t.minus + "",
    h = void 0 === t.nan ? "NaN" : t.nan + "";
  function c(t) {
    var e = (t = Li(t)).fill,
      n = t.align,
      c = t.sign,
      f = t.symbol,
      d = t.zero,
      p = t.width,
      g = t.comma,
      v = t.precision,
      m = t.trim,
      y = t.type;
    "n" === y ? (g = !0, y = "g") : Vi[y] || (void 0 === v && (v = 12), m = !0, y = "g"), (d || "0" === e && "=" === n) && (d = !0, e = "0", n = "=");
    var _ = "$" === f ? i : "#" === f && /[boxX]/.test(y) ? "0" + y.toLowerCase() : "",
      w = "$" === f ? s : /[%p]/.test(y) ? l : "",
      b = Vi[y],
      $ = /[defgprs%]/.test(y);
    function A(t) {
      var i,
        s,
        l,
        f = _,
        A = w;
      if ("c" === y) A = b(t) + A, t = "";else {
        var x = (t = +t) < 0 || 1 / t < 0;
        if (t = isNaN(t) ? h : b(Math.abs(t), v), m && (t = function (t) {
          t: for (var e, n = t.length, r = 1, i = -1; r < n; ++r) switch (t[r]) {
            case ".":
              i = e = r;
              break;
            case "0":
              0 === i && (i = r), e = r;
              break;
            default:
              if (!+t[r]) break t;
              i > 0 && (i = 0);
          }
          return i > 0 ? t.slice(0, i) + t.slice(e + 1) : t;
        }(t)), x && 0 == +t && "+" !== c && (x = !1), f = (x ? "(" === c ? c : u : "-" === c || "(" === c ? "" : c) + f, A = ("s" === y ? Fi[8 + Ui / 3] : "") + A + (x && "(" === c ? ")" : ""), $) for (i = -1, s = t.length; ++i < s;) if (48 > (l = t.charCodeAt(i)) || l > 57) {
          A = (46 === l ? o + t.slice(i + 1) : t.slice(i)) + A, t = t.slice(0, i);
          break;
        }
      }
      g && !d && (t = r(t, 1 / 0));
      var E = f.length + t.length + A.length,
        M = E < p ? new Array(p - E + 1).join(e) : "";
      switch (g && d && (t = r(M + t, M.length ? p - A.length : 1 / 0), M = ""), n) {
        case "<":
          t = f + t + A + M;
          break;
        case "=":
          t = f + M + t + A;
          break;
        case "^":
          t = M.slice(0, E = M.length >> 1) + f + t + A + M.slice(E);
          break;
        default:
          t = M + f + t + A;
      }
      return a(t);
    }
    return v = void 0 === v ? 6 : /[gprs]/.test(y) ? Math.max(1, Math.min(21, v)) : Math.max(0, Math.min(20, v)), A.toString = function () {
      return t + "";
    }, A;
  }
  return {
    format: c,
    formatPrefix: function (t, e) {
      var n = c(((t = Li(t)).type = "f", t)),
        r = 3 * Math.max(-8, Math.min(8, Math.floor(zi(e) / 3))),
        i = Math.pow(10, -r),
        s = Fi[8 + r / 3];
      return function (t) {
        return n(i * t) + s;
      };
    }
  };
}
function Gi(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
  }
  return this;
}
function Zi(t) {
  return +t;
}
qi = Ki({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
}), Xi = qi.format, Wi = qi.formatPrefix;
var Ji,
  Qi,
  ts,
  es,
  ns,
  rs,
  is,
  ss,
  os,
  as,
  ls,
  us,
  hs,
  cs = [0, 1];
function fs(t) {
  return t;
}
function ds(t, e) {
  return (e -= t = +t) ? function (n) {
    return (n - t) / e;
  } : function (t) {
    return function () {
      return t;
    };
  }(isNaN(e) ? NaN : .5);
}
function ps(t, e, n) {
  var r = t[0],
    i = t[1],
    s = e[0],
    o = e[1];
  return i < r ? (r = ds(i, r), s = n(o, s)) : (r = ds(r, i), s = n(s, o)), function (t) {
    return s(r(t));
  };
}
function gs(t, e, n) {
  var r = Math.min(t.length, e.length) - 1,
    i = new Array(r),
    s = new Array(r),
    o = -1;
  for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++o < r;) i[o] = ds(t[o], t[o + 1]), s[o] = n(e[o], e[o + 1]);
  return function (e) {
    var n = wt(t, e, 1, r) - 1;
    return s[n](i[n](e));
  };
}
function vs() {
  var t,
    e,
    n,
    r,
    i,
    s,
    o = cs,
    a = cs,
    l = Jn,
    u = fs;
  function h() {
    var t = Math.min(o.length, a.length);
    return u !== fs && (u = function (t, e) {
      var n;
      return t > e && (n = t, t = e, e = n), function (n) {
        return Math.max(t, Math.min(e, n));
      };
    }(o[0], o[t - 1])), r = t > 2 ? gs : ps, i = s = null, c;
  }
  function c(e) {
    return null == e || isNaN(e = +e) ? n : (i || (i = r(o.map(t), a, l)))(t(u(e)));
  }
  return c.invert = function (n) {
    return u(e((s || (s = r(a, o.map(t), Yn)))(n)));
  }, c.domain = function (t) {
    return arguments.length ? (o = Array.from(t, Zi), h()) : o.slice();
  }, c.range = function (t) {
    return arguments.length ? (a = Array.from(t), h()) : a.slice();
  }, c.rangeRound = function (t) {
    return a = Array.from(t), l = Qn, h();
  }, c.clamp = function (t) {
    return arguments.length ? (u = !!t || fs, h()) : u !== fs;
  }, c.interpolate = function (t) {
    return arguments.length ? (l = t, h()) : l;
  }, c.unknown = function (t) {
    return arguments.length ? (n = t, c) : n;
  }, function (n, r) {
    return t = n, e = r, h();
  };
}
function ms(t, e, n, r) {
  var i,
    s = function (t, e, n) {
      n = +n;
      const r = (e = +e) < (t = +t),
        i = r ? Et(e, t, n) : Et(t, e, n);
      return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
    }(t, e, n);
  switch ((r = Li(r ?? ",f")).type) {
    case "s":
      var o = Math.max(Math.abs(t), Math.abs(e));
      return null != r.precision || isNaN(i = function (t, e) {
        return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(zi(e) / 3))) - zi(Math.abs(t)));
      }(s, o)) || (r.precision = i), Wi(r, o);
    case "":
    case "e":
    case "g":
    case "p":
    case "r":
      null != r.precision || isNaN(i = function (t, e) {
        return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, zi(e) - zi(t)) + 1;
      }(s, Math.max(Math.abs(t), Math.abs(e)))) || (r.precision = i - ("e" === r.type));
      break;
    case "f":
    case "%":
      null != r.precision || isNaN(i = function (t) {
        return Math.max(0, -zi(Math.abs(t)));
      }(s)) || (r.precision = i - 2 * ("%" === r.type));
  }
  return Xi(r);
}
function ys(t) {
  var e = t.domain;
  return t.ticks = function (t) {
    var n = e();
    return function (t, e, n) {
      if (!((n = +n) > 0)) return [];
      if ((t = +t) == (e = +e)) return [t];
      const r = e < t,
        [i, s, o] = r ? xt(e, t, n) : xt(t, e, n);
      if (!(s >= i)) return [];
      const a = s - i + 1,
        l = new Array(a);
      if (r) {
        if (o < 0) for (let t = 0; t < a; ++t) l[t] = (s - t) / -o;else for (let t = 0; t < a; ++t) l[t] = (s - t) * o;
      } else if (o < 0) for (let t = 0; t < a; ++t) l[t] = (i + t) / -o;else for (let t = 0; t < a; ++t) l[t] = (i + t) * o;
      return l;
    }(n[0], n[n.length - 1], t ?? 10);
  }, t.tickFormat = function (t, n) {
    var r = e();
    return ms(r[0], r[r.length - 1], t ?? 10, n);
  }, t.nice = function (n) {
    null == n && (n = 10);
    var r,
      i,
      s = e(),
      o = 0,
      a = s.length - 1,
      l = s[o],
      u = s[a],
      h = 10;
    for (u < l && (i = l, l = u, u = i, i = o, o = a, a = i); h-- > 0;) {
      if ((i = Et(l, u, n)) === r) return s[o] = l, s[a] = u, e(s);
      if (i > 0) l = Math.floor(l / i) * i, u = Math.ceil(u / i) * i;else {
        if (!(i < 0)) break;
        l = Math.ceil(l * i) / i, u = Math.floor(u * i) / i;
      }
      r = i;
    }
    return t;
  }, t;
}
function _s() {
  var t = vs()(fs, fs);
  return t.copy = function () {
    return e = t, _s().domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
    var e;
  }, Gi.apply(t, arguments), ys(t);
}
function ws(t, e, n) {
  this.k = t, this.x = e, this.y = n;
}
ws.prototype = {
  constructor: ws,
  scale: function (t) {
    return 1 === t ? this : new ws(this.k * t, this.x, this.y);
  },
  translate: function (t, e) {
    return 0 === t & 0 === e ? this : new ws(this.k, this.x + this.k * t, this.y + this.k * e);
  },
  apply: function (t) {
    return [t[0] * this.k + this.x, t[1] * this.k + this.y];
  },
  applyX: function (t) {
    return t * this.k + this.x;
  },
  applyY: function (t) {
    return t * this.k + this.y;
  },
  invert: function (t) {
    return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
  },
  invertX: function (t) {
    return (t - this.x) / this.k;
  },
  invertY: function (t) {
    return (t - this.y) / this.k;
  },
  rescaleX: function (t) {
    return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
  },
  rescaleY: function (t) {
    return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
  },
  toString: function () {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
}, ws.prototype;
let bs = class extends e(n(r(i(s(o(t)))))) {
  constructor() {
    super(), Ji.set(this, void 0), Qi.set(this, void 0), ts.set(this, void 0), es.set(this, void 0), ns.set(this, void 0), rs.set(this, void 0), is.set(this, void 0), ss.set(this, void 0), os.set(this, void 0), as.set(this, void 0), ls.set(this, void 0), us.set(this, void 0), hs.set(this, null), this["ruler-start"] = 1, this["ruler-padding"] = 10, this["scale-factor"] = (this.length || 0) / 5 || 10, this["show-highlight"] = !1, u(this, Ji, null, "f"), u(this, Qi, !1, "f");
  }
  createNavRuler() {
    const t = this.width - this["margin-right"] - this["ruler-padding"];
    var e;
    u(this, Ji, _s().range([this["margin-left"] + this["ruler-padding"], t]).domain([this["ruler-start"], this["ruler-start"] + (this.length || 1)]), "f"), u(this, ts, en(this).selectAll("svg").attr("id", "").attr("width", this.width).attr("height", this.height), "f"), u(this, os, (e = l(this, Ji, "f"), Ut(Nt, e)), "f"), u(this, es, l(this, ts, "f").append("text").attr("class", "start-label").attr("x", this["margin-left"]).attr("y", this.height - this["margin-bottom"] - 2).style("font-family", "sans-serif").style("font-size", 12), "f"), u(this, ns, l(this, ts, "f").append("text").attr("class", "end-label").attr("x", this.width - this["margin-right"]).attr("y", this.height - this["margin-bottom"] - 2).attr("text-anchor", "end").style("font-family", "sans-serif").style("font-size", 12), "f"), u(this, rs, l(this, ts, "f").append("g").attr("class", "x axis").call(l(this, os, "f")), "f"), u(this, as, Oi().extent([[this["margin-left"] + this["ruler-padding"], 0], [t, .5 * this.height + 3]]).handleSize(6).on("end", ({
      selection: t
    }) => {
      null === t && l(this, hs, "f") && l(this, is, "f") && l(this, as, "f") && l(this, is, "f").call(l(this, as, "f").move, l(this, hs, "f"));
    }).on("brush", ({
      selection: t,
      transform: e
    }) => {
      t && l(this, Ji, "f") && (u(this, hs, t, "f"), this["display-start"] = Math.round(100 * l(this, Ji, "f").invert(t[0])) / 100, this["display-end"] = Math.round(100 * l(this, Ji, "f").invert(t[1])) / 100, l(this, Qi, "f") || this.dispatchEvent(new CustomEvent("change", {
        detail: {
          "display-end": this["display-end"],
          "display-start": this["display-start"],
          extra: {
            transform: e
          }
        },
        bubbles: !0,
        cancelable: !0
      })), this.updateLabels(), this.updatePolygon());
    }), "f"), u(this, is, l(this, ts, "f").append("g").attr("class", "brush"), "f"), t > 0 && (l(this, is, "f").call(l(this, as, "f")), l(this, is, "f").call(l(this, as, "f").move, [l(this, Ji, "f").call(this, this.getStart()), l(this, Ji, "f").call(this, this.getEnd())])), u(this, ss, l(this, ts, "f").append("polygon").attr("class", "zoom-polygon").attr("fill", "#777").attr("fill-opacity", "0.3"), "f"), u(this, us, l(this, ts, "f").append("g").attr("class", "margin"), "f"), this.createHighlight(), this.renderD3();
  }
  createHighlight() {
    l(this, ts, "f") && (u(this, ls, l(this, ts, "f").append("g").attr("class", "highlighted"), "f"), this.updateHighlight());
  }
  onDimensionsChange() {
    var t, e, n, r;
    l(this, Ji, "f") && (l(this, Ji, "f").range([this["margin-left"] + this["ruler-padding"], this.width - this["margin-right"] - this["ruler-padding"]]), null === (t = l(this, ts, "f")) || void 0 === t || t.attr("width", this.width), null === (e = l(this, ts, "f")) || void 0 === e || e.attr("height", this.height), null === (n = l(this, as, "f")) || void 0 === n || n.extent([[this["margin-left"] + this["ruler-padding"], 0], [this.width - this["margin-right"] - this["ruler-padding"], .5 * this.height + 3]]), l(this, as, "f") && (null === (r = l(this, is, "f")) || void 0 === r || r.call(l(this, as, "f"))));
  }
  render() {
    return X`<svg class="container"></svg>`;
  }
  updated(t) {
    this.renderD3(), super.updated(t);
  }
  firstUpdated() {
    this.createNavRuler();
  }
  renderD3() {
    if (l(this, Ji, "f") && l(this, rs, "f") && l(this, os, "f") && l(this, as, "f")) {
      l(this, Ji, "f").domain([this["ruler-start"], this["ruler-start"] + (this.length || 1) - 1]), l(this, rs, "f").call(l(this, os, "f")), this.updatePolygon(), this.updateLabels();
      const t = [l(this, Ji, "f").call(this, this.getStart()), l(this, Ji, "f").call(this, this.getEnd())];
      l(this, is, "f") && t[0] >= 0 && t[1] >= 0 && (u(this, Qi, !0, "f"), l(this, is, "f").call(l(this, as, "f").move, t), u(this, Qi, !1, "f")), this.updateHighlight(), this.renderMarginOnGroup(l(this, us, "f"));
    }
  }
  locate(t, e) {
    l(this, is, "f") && l(this, as, "f") && l(this, Ji, "f") && l(this, is, "f").call(l(this, as, "f").move, [l(this, Ji, "f").call(this, t), l(this, Ji, "f").call(this, e)]);
  }
  zoomOut() {
    this.locate(Math.max(this["ruler-start"] || 1, this.getStart() - this["scale-factor"]), Math.min((this.length || 1) + this["ruler-start"] - 1, this.getEnd() + this["scale-factor"]));
  }
  zoomIn() {
    const t = Math.min(this.getStart() + this["scale-factor"], this.getEnd() - 1);
    this.locate(t, Math.max(this.getEnd() - this["scale-factor"], t + 1));
  }
  updateHighlight() {
    if (!l(this, ls, "f")) return;
    const t = _s().domain([this["display-start"] || 1, (this["display-end"] || this.length || 1) + 1]).range([this["margin-left"], this.width - this["margin-right"]]),
      e = _s().domain([this["ruler-start"], this["ruler-start"] + (this.length || 1)]).range([this["margin-left"] + this["ruler-padding"], this.width - this["margin-right"] - this["ruler-padding"]]),
      n = l(this, ls, "f").selectAll("polygon").data(this["show-highlight"] ? this.highlightedRegion.segments : []);
    n.enter().append("polygon").attr("class", "highlight-polygon").style("pointer-events", "none").merge(n).attr("fill", this["highlight-color"]).attr("points", n => {
      const r = Math.max(1, n.start),
        i = Math.min(this.length || 1, n.end) + 1;
      return `${e(r)},${this.height / 2}\n        ${e(i)},${this.height / 2}\n        ${t(i)},${this.height}\n        ${t(r)},${this.height}`;
    }), n.exit().remove();
    const r = l(this, ls, "f").selectAll("rect").data(this["show-highlight"] ? this.highlightedRegion.segments : []);
    r.enter().append("rect").attr("class", "highlight-rectangle").style("pointer-events", "none").merge(r).attr("fill", this["highlight-color"]).attr("x", t => e(Math.max(1, t.start))).attr("width", t => e(Math.min(this.length || 1, t.end) + 1) - e(Math.max(1, t.start))).attr("y", this["margin-top"]).attr("height", this.height / 2), r.exit().remove();
  }
  updateLabels() {
    l(this, es, "f") && l(this, es, "f").attr("x", this["margin-left"]).text(Math.round(this.getStart())), l(this, ns, "f") && l(this, ns, "f").attr("x", this.width - this["margin-right"]).text(Math.round(this.getEnd()));
  }
  updatePolygon() {
    l(this, ss, "f") && l(this, Ji, "f") && l(this, ss, "f").attr("points", `${l(this, Ji, "f").call(this, this.getStart())},${this.height / 2}\n        ${l(this, Ji, "f").call(this, this.getEnd())},${this.height / 2}\n        ${this.width - this["margin-right"]},${this.height}\n        ${this["margin-left"]},${this.height}`);
  }
  getStart() {
    return this["display-start"] || 1;
  }
  getEnd() {
    return ((this["display-end"] || 0) > 0 ? this["display-end"] : this.length) || 1;
  }
};
Ji = new WeakMap(), Qi = new WeakMap(), ts = new WeakMap(), es = new WeakMap(), ns = new WeakMap(), rs = new WeakMap(), is = new WeakMap(), ss = new WeakMap(), os = new WeakMap(), as = new WeakMap(), ls = new WeakMap(), us = new WeakMap(), hs = new WeakMap(), a([dt({
  type: Number
})], bs.prototype, "ruler-start", void 0), a([dt({
  type: Number
})], bs.prototype, "ruler-padding", void 0), a([dt({
  type: Number
})], bs.prototype, "scale-factor", void 0), a([dt({
  type: Boolean
})], bs.prototype, "show-highlight", void 0), bs = a([(t => e => "function" == typeof e ? ((t, e) => (customElements.define(t, e), e))(t, e) : ((t, e) => {
  const {
    kind: n,
    elements: r
  } = e;
  return {
    kind: n,
    elements: r,
    finisher(e) {
      customElements.define(t, e);
    }
  };
})(t, e))("nightingale-navigation")], bs);
var $s = bs;
export { $s as default };
